/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const bookAppointment = /* GraphQL */ `
  mutation BookAppointment($input: AppointmentInput!) {
    bookAppointment(input: $input)
  }
`;
export const scheduleAcuityAppointment = /* GraphQL */ `
  mutation ScheduleAcuityAppointment($input: AcuityAppointmentInput) {
    scheduleAcuityAppointment(input: $input)
  }
`;
export const cancelAppointment = /* GraphQL */ `
  mutation CancelAppointment(
    $id: ID!
    $acuityAppointmentId: String!
    $userId: ID!
    $coachId: ID!
    $appointmentType: AppointmentTypeEnum!
    $isAdmin: Boolean
    $noShow: Boolean
    $cancelNote: String
  ) {
    cancelAppointment(
      id: $id
      acuityAppointmentId: $acuityAppointmentId
      userId: $userId
      coachId: $coachId
      appointmentType: $appointmentType
      isAdmin: $isAdmin
      noShow: $noShow
      cancelNote: $cancelNote
    )
  }
`;
export const upsertACTag = /* GraphQL */ `
  mutation UpsertACTag($user: ACUserInput!, $tags: String!) {
    upsertACTag(user: $user, tags: $tags)
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      email
      firstName
      lastName
      phone
      address {
        houseNumber
        street
        streetType
        address1
        address2
        address3
        city
        state
        postalCode
        county
        country
        latLng {
          lat
          lon
        }
      }
      avatar
      userBio
      age
      dateOfBirth
      genderId
      createdAt
      status
      lastSeen
      referralSource
      roles
      stage
      plans {
        items {
          id
          userId
          planId
          plan {
            id
            planGroupId
            name
            description
            active
            defaultPrice
            defaultPlanPriceId
            discountsAllowed
            display
            isTrial
            upgradeable
            downgradeable
            features
            createdAt
            level
            updatedAt
          }
          planGroupId
          planGroup {
            id
            name
            startDate
            endDate
            trialPeriod
            createdAt
            active
            updatedAt
          }
          planPricingSlug
          planPricing {
            planId
            slug
            default
            activationCodes
            downgradePricingIds
            upgradePricingIds
            price
            createdAt
            updatedAt
          }
          startDate
          endDate
          cancelled
          cancellationReason
          createdAt
          active
          metadata {
            stripeSubscriptionId
            stripeCustomerId
          }
          updatedAt
        }
        nextToken
      }
      appointments {
        items {
          id
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          appointmentStartTime
          appointmentEndTime
          appointmentDurationMins
          appointmentTimezone
          appointmentType
          cancelled
          cancelDate
          cancelReason
          cancelNote
          metadata {
            acuityAppointmentId
            acuityAppointmentTypeId
            acuityConfirmationPageUrl
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      coaches {
        items {
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          isPrimary
          active
          coachingStartDate
          coachingEndDate
          ratings {
            nextToken
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      growthPaths {
        items {
          id
          growthPathItemId
          growthPathItem {
            id
            type
            title
            subtitle
            avatarUrl
            description
            categoryName
            categoryId
            estimatedCompletionTimeInMins
            actionTitle
            actionDestination
            actionPayload
            createdAt
            expirationDate
            lessonId
            tags
            isArchived
            updatedAt
          }
          userId
          order
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          dateTimeAdded
          completed
          dismissed
          completedTimestamp
          expirationDate
          locked
          hidden
          isScheduled
          visibleDate
          visibleTimestamp
          growthPathJourneyId
          growthPathJourneyStep
          growthPathJourney {
            id
            title
            description
            focusAreaId
            active
            createdAt
            updatedAt
          }
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          source
          lastActivityTimestamp
          dependsOnGrowthPathItems
          createdAt
          updatedAt
        }
        nextToken
      }
      metadata {
        lastLogin
        trialStartDate
        trialEndDate
        subscriptionStatus
        deviceId
        deviceOS
        deviceOSVersion
        allowAccountNotifications
        allowMarketingNotifications
        allowCoachingNotifications
        initialAssessmentCompletedDate
        lastWeeklyCheckinDate
        lastGrowthStageAssessmentDate
        primaryFocusCategoryId
        primaryFocusGoalId
        secondaryFocusCategoryId
        secondaryFocusGoalId
        tertiaryFocusCategoryId
        tertiaryFocusGoalId
        preferredCoachingTimeOfDay
        preferredCoachingDaysOfWeek
        primaryCoachId
        userIPAddress
        intakeCompleted
        onboardingCompleted
        issCompleted
        stipeCustomerId
        lastActive
      }
      updatedAt
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      email
      firstName
      lastName
      phone
      address {
        houseNumber
        street
        streetType
        address1
        address2
        address3
        city
        state
        postalCode
        county
        country
        latLng {
          lat
          lon
        }
      }
      avatar
      userBio
      age
      dateOfBirth
      genderId
      createdAt
      status
      lastSeen
      referralSource
      roles
      stage
      plans {
        items {
          id
          userId
          planId
          plan {
            id
            planGroupId
            name
            description
            active
            defaultPrice
            defaultPlanPriceId
            discountsAllowed
            display
            isTrial
            upgradeable
            downgradeable
            features
            createdAt
            level
            updatedAt
          }
          planGroupId
          planGroup {
            id
            name
            startDate
            endDate
            trialPeriod
            createdAt
            active
            updatedAt
          }
          planPricingSlug
          planPricing {
            planId
            slug
            default
            activationCodes
            downgradePricingIds
            upgradePricingIds
            price
            createdAt
            updatedAt
          }
          startDate
          endDate
          cancelled
          cancellationReason
          createdAt
          active
          metadata {
            stripeSubscriptionId
            stripeCustomerId
          }
          updatedAt
        }
        nextToken
      }
      appointments {
        items {
          id
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          appointmentStartTime
          appointmentEndTime
          appointmentDurationMins
          appointmentTimezone
          appointmentType
          cancelled
          cancelDate
          cancelReason
          cancelNote
          metadata {
            acuityAppointmentId
            acuityAppointmentTypeId
            acuityConfirmationPageUrl
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      coaches {
        items {
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          isPrimary
          active
          coachingStartDate
          coachingEndDate
          ratings {
            nextToken
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      growthPaths {
        items {
          id
          growthPathItemId
          growthPathItem {
            id
            type
            title
            subtitle
            avatarUrl
            description
            categoryName
            categoryId
            estimatedCompletionTimeInMins
            actionTitle
            actionDestination
            actionPayload
            createdAt
            expirationDate
            lessonId
            tags
            isArchived
            updatedAt
          }
          userId
          order
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          dateTimeAdded
          completed
          dismissed
          completedTimestamp
          expirationDate
          locked
          hidden
          isScheduled
          visibleDate
          visibleTimestamp
          growthPathJourneyId
          growthPathJourneyStep
          growthPathJourney {
            id
            title
            description
            focusAreaId
            active
            createdAt
            updatedAt
          }
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          source
          lastActivityTimestamp
          dependsOnGrowthPathItems
          createdAt
          updatedAt
        }
        nextToken
      }
      metadata {
        lastLogin
        trialStartDate
        trialEndDate
        subscriptionStatus
        deviceId
        deviceOS
        deviceOSVersion
        allowAccountNotifications
        allowMarketingNotifications
        allowCoachingNotifications
        initialAssessmentCompletedDate
        lastWeeklyCheckinDate
        lastGrowthStageAssessmentDate
        primaryFocusCategoryId
        primaryFocusGoalId
        secondaryFocusCategoryId
        secondaryFocusGoalId
        tertiaryFocusCategoryId
        tertiaryFocusGoalId
        preferredCoachingTimeOfDay
        preferredCoachingDaysOfWeek
        primaryCoachId
        userIPAddress
        intakeCompleted
        onboardingCompleted
        issCompleted
        stipeCustomerId
        lastActive
      }
      updatedAt
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      email
      firstName
      lastName
      phone
      address {
        houseNumber
        street
        streetType
        address1
        address2
        address3
        city
        state
        postalCode
        county
        country
        latLng {
          lat
          lon
        }
      }
      avatar
      userBio
      age
      dateOfBirth
      genderId
      createdAt
      status
      lastSeen
      referralSource
      roles
      stage
      plans {
        items {
          id
          userId
          planId
          plan {
            id
            planGroupId
            name
            description
            active
            defaultPrice
            defaultPlanPriceId
            discountsAllowed
            display
            isTrial
            upgradeable
            downgradeable
            features
            createdAt
            level
            updatedAt
          }
          planGroupId
          planGroup {
            id
            name
            startDate
            endDate
            trialPeriod
            createdAt
            active
            updatedAt
          }
          planPricingSlug
          planPricing {
            planId
            slug
            default
            activationCodes
            downgradePricingIds
            upgradePricingIds
            price
            createdAt
            updatedAt
          }
          startDate
          endDate
          cancelled
          cancellationReason
          createdAt
          active
          metadata {
            stripeSubscriptionId
            stripeCustomerId
          }
          updatedAt
        }
        nextToken
      }
      appointments {
        items {
          id
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          appointmentStartTime
          appointmentEndTime
          appointmentDurationMins
          appointmentTimezone
          appointmentType
          cancelled
          cancelDate
          cancelReason
          cancelNote
          metadata {
            acuityAppointmentId
            acuityAppointmentTypeId
            acuityConfirmationPageUrl
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      coaches {
        items {
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          isPrimary
          active
          coachingStartDate
          coachingEndDate
          ratings {
            nextToken
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      growthPaths {
        items {
          id
          growthPathItemId
          growthPathItem {
            id
            type
            title
            subtitle
            avatarUrl
            description
            categoryName
            categoryId
            estimatedCompletionTimeInMins
            actionTitle
            actionDestination
            actionPayload
            createdAt
            expirationDate
            lessonId
            tags
            isArchived
            updatedAt
          }
          userId
          order
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          dateTimeAdded
          completed
          dismissed
          completedTimestamp
          expirationDate
          locked
          hidden
          isScheduled
          visibleDate
          visibleTimestamp
          growthPathJourneyId
          growthPathJourneyStep
          growthPathJourney {
            id
            title
            description
            focusAreaId
            active
            createdAt
            updatedAt
          }
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          source
          lastActivityTimestamp
          dependsOnGrowthPathItems
          createdAt
          updatedAt
        }
        nextToken
      }
      metadata {
        lastLogin
        trialStartDate
        trialEndDate
        subscriptionStatus
        deviceId
        deviceOS
        deviceOSVersion
        allowAccountNotifications
        allowMarketingNotifications
        allowCoachingNotifications
        initialAssessmentCompletedDate
        lastWeeklyCheckinDate
        lastGrowthStageAssessmentDate
        primaryFocusCategoryId
        primaryFocusGoalId
        secondaryFocusCategoryId
        secondaryFocusGoalId
        tertiaryFocusCategoryId
        tertiaryFocusGoalId
        preferredCoachingTimeOfDay
        preferredCoachingDaysOfWeek
        primaryCoachId
        userIPAddress
        intakeCompleted
        onboardingCompleted
        issCompleted
        stipeCustomerId
        lastActive
      }
      updatedAt
    }
  }
`;
export const createUserCoach = /* GraphQL */ `
  mutation CreateUserCoach(
    $input: CreateUserCoachInput!
    $condition: ModelUserCoachConditionInput
  ) {
    createUserCoach(input: $input, condition: $condition) {
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      isPrimary
      active
      coachingStartDate
      coachingEndDate
      ratings {
        items {
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          rating
          comment
          ratingTimestamp
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateUserCoach = /* GraphQL */ `
  mutation UpdateUserCoach(
    $input: UpdateUserCoachInput!
    $condition: ModelUserCoachConditionInput
  ) {
    updateUserCoach(input: $input, condition: $condition) {
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      isPrimary
      active
      coachingStartDate
      coachingEndDate
      ratings {
        items {
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          rating
          comment
          ratingTimestamp
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserCoach = /* GraphQL */ `
  mutation DeleteUserCoach(
    $input: DeleteUserCoachInput!
    $condition: ModelUserCoachConditionInput
  ) {
    deleteUserCoach(input: $input, condition: $condition) {
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      isPrimary
      active
      coachingStartDate
      coachingEndDate
      ratings {
        items {
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          rating
          comment
          ratingTimestamp
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createUserCoachRating = /* GraphQL */ `
  mutation CreateUserCoachRating(
    $input: CreateUserCoachRatingInput!
    $condition: ModelUserCoachRatingConditionInput
  ) {
    createUserCoachRating(input: $input, condition: $condition) {
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      rating
      comment
      ratingTimestamp
      createdAt
      updatedAt
    }
  }
`;
export const updateUserCoachRating = /* GraphQL */ `
  mutation UpdateUserCoachRating(
    $input: UpdateUserCoachRatingInput!
    $condition: ModelUserCoachRatingConditionInput
  ) {
    updateUserCoachRating(input: $input, condition: $condition) {
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      rating
      comment
      ratingTimestamp
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserCoachRating = /* GraphQL */ `
  mutation DeleteUserCoachRating(
    $input: DeleteUserCoachRatingInput!
    $condition: ModelUserCoachRatingConditionInput
  ) {
    deleteUserCoachRating(input: $input, condition: $condition) {
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      rating
      comment
      ratingTimestamp
      createdAt
      updatedAt
    }
  }
`;
export const createUserCoachingNote = /* GraphQL */ `
  mutation CreateUserCoachingNote(
    $input: CreateUserCoachingNoteInput!
    $condition: ModelUserCoachingNoteConditionInput
  ) {
    createUserCoachingNote(input: $input, condition: $condition) {
      id
      userId
      coachId
      appointmentId
      appointment {
        id
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        coachId
        coach {
          id
          firstName
          lastName
          email
          title
          coachType
          avatarUrl
          description
          metadata {
            introVideoUrl
            gcalId
            calendlyId
            acuityCalendarId
            acuityUserId
            acuityKey
            acuityIssAppointmentId
            acuityRegularAppointmentId
            streamChatId
            slackId
            lastCoachNote
            lastChatMessage
          }
          focusAreas {
            nextToken
          }
          members {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        appointmentStartTime
        appointmentEndTime
        appointmentDurationMins
        appointmentTimezone
        appointmentType
        cancelled
        cancelDate
        cancelReason
        cancelNote
        metadata {
          acuityAppointmentId
          acuityAppointmentTypeId
          acuityConfirmationPageUrl
        }
        createdAt
        updatedAt
      }
      note
      visibleToUser
      createdAt
      updatedAt
    }
  }
`;
export const updateUserCoachingNote = /* GraphQL */ `
  mutation UpdateUserCoachingNote(
    $input: UpdateUserCoachingNoteInput!
    $condition: ModelUserCoachingNoteConditionInput
  ) {
    updateUserCoachingNote(input: $input, condition: $condition) {
      id
      userId
      coachId
      appointmentId
      appointment {
        id
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        coachId
        coach {
          id
          firstName
          lastName
          email
          title
          coachType
          avatarUrl
          description
          metadata {
            introVideoUrl
            gcalId
            calendlyId
            acuityCalendarId
            acuityUserId
            acuityKey
            acuityIssAppointmentId
            acuityRegularAppointmentId
            streamChatId
            slackId
            lastCoachNote
            lastChatMessage
          }
          focusAreas {
            nextToken
          }
          members {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        appointmentStartTime
        appointmentEndTime
        appointmentDurationMins
        appointmentTimezone
        appointmentType
        cancelled
        cancelDate
        cancelReason
        cancelNote
        metadata {
          acuityAppointmentId
          acuityAppointmentTypeId
          acuityConfirmationPageUrl
        }
        createdAt
        updatedAt
      }
      note
      visibleToUser
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserCoachingNote = /* GraphQL */ `
  mutation DeleteUserCoachingNote(
    $input: DeleteUserCoachingNoteInput!
    $condition: ModelUserCoachingNoteConditionInput
  ) {
    deleteUserCoachingNote(input: $input, condition: $condition) {
      id
      userId
      coachId
      appointmentId
      appointment {
        id
        userId
        user {
          id
          email
          firstName
          lastName
          phone
          address {
            houseNumber
            street
            streetType
            address1
            address2
            address3
            city
            state
            postalCode
            county
            country
          }
          avatar
          userBio
          age
          dateOfBirth
          genderId
          createdAt
          status
          lastSeen
          referralSource
          roles
          stage
          plans {
            nextToken
          }
          appointments {
            nextToken
          }
          coaches {
            nextToken
          }
          growthPaths {
            nextToken
          }
          metadata {
            lastLogin
            trialStartDate
            trialEndDate
            subscriptionStatus
            deviceId
            deviceOS
            deviceOSVersion
            allowAccountNotifications
            allowMarketingNotifications
            allowCoachingNotifications
            initialAssessmentCompletedDate
            lastWeeklyCheckinDate
            lastGrowthStageAssessmentDate
            primaryFocusCategoryId
            primaryFocusGoalId
            secondaryFocusCategoryId
            secondaryFocusGoalId
            tertiaryFocusCategoryId
            tertiaryFocusGoalId
            preferredCoachingTimeOfDay
            preferredCoachingDaysOfWeek
            primaryCoachId
            userIPAddress
            intakeCompleted
            onboardingCompleted
            issCompleted
            stipeCustomerId
            lastActive
          }
          updatedAt
        }
        coachId
        coach {
          id
          firstName
          lastName
          email
          title
          coachType
          avatarUrl
          description
          metadata {
            introVideoUrl
            gcalId
            calendlyId
            acuityCalendarId
            acuityUserId
            acuityKey
            acuityIssAppointmentId
            acuityRegularAppointmentId
            streamChatId
            slackId
            lastCoachNote
            lastChatMessage
          }
          focusAreas {
            nextToken
          }
          members {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        appointmentStartTime
        appointmentEndTime
        appointmentDurationMins
        appointmentTimezone
        appointmentType
        cancelled
        cancelDate
        cancelReason
        cancelNote
        metadata {
          acuityAppointmentId
          acuityAppointmentTypeId
          acuityConfirmationPageUrl
        }
        createdAt
        updatedAt
      }
      note
      visibleToUser
      createdAt
      updatedAt
    }
  }
`;
export const createUserStats = /* GraphQL */ `
  mutation CreateUserStats(
    $input: CreateUserStatsInput!
    $condition: ModelUserStatsConditionInput
  ) {
    createUserStats(input: $input, condition: $condition) {
      userId
      totalHabitLogged
      totalAppointmentsScheduled
      totalLessonsWatched
      totalLogins
      totalMessages
      createdAt
      updatedAt
    }
  }
`;
export const updateUserStats = /* GraphQL */ `
  mutation UpdateUserStats(
    $input: UpdateUserStatsInput!
    $condition: ModelUserStatsConditionInput
  ) {
    updateUserStats(input: $input, condition: $condition) {
      userId
      totalHabitLogged
      totalAppointmentsScheduled
      totalLessonsWatched
      totalLogins
      totalMessages
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserStats = /* GraphQL */ `
  mutation DeleteUserStats(
    $input: DeleteUserStatsInput!
    $condition: ModelUserStatsConditionInput
  ) {
    deleteUserStats(input: $input, condition: $condition) {
      userId
      totalHabitLogged
      totalAppointmentsScheduled
      totalLessonsWatched
      totalLogins
      totalMessages
      createdAt
      updatedAt
    }
  }
`;
export const createUserActivityLog = /* GraphQL */ `
  mutation CreateUserActivityLog(
    $input: CreateUserActivityLogInput!
    $condition: ModelUserActivityLogConditionInput
  ) {
    createUserActivityLog(input: $input, condition: $condition) {
      id
      type
      source
      payload
      timestamp
      createdAt
      updatedAt
    }
  }
`;
export const updateUserActivityLog = /* GraphQL */ `
  mutation UpdateUserActivityLog(
    $input: UpdateUserActivityLogInput!
    $condition: ModelUserActivityLogConditionInput
  ) {
    updateUserActivityLog(input: $input, condition: $condition) {
      id
      type
      source
      payload
      timestamp
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserActivityLog = /* GraphQL */ `
  mutation DeleteUserActivityLog(
    $input: DeleteUserActivityLogInput!
    $condition: ModelUserActivityLogConditionInput
  ) {
    deleteUserActivityLog(input: $input, condition: $condition) {
      id
      type
      source
      payload
      timestamp
      createdAt
      updatedAt
    }
  }
`;
export const createJournalEntryTemplates = /* GraphQL */ `
  mutation CreateJournalEntryTemplates(
    $input: CreateJournalEntryTemplatesInput!
    $condition: ModelJournalEntryTemplatesConditionInput
  ) {
    createJournalEntryTemplates(input: $input, condition: $condition) {
      id
      name
      description
      templateText
      templateBlocks {
        label
        value
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateJournalEntryTemplates = /* GraphQL */ `
  mutation UpdateJournalEntryTemplates(
    $input: UpdateJournalEntryTemplatesInput!
    $condition: ModelJournalEntryTemplatesConditionInput
  ) {
    updateJournalEntryTemplates(input: $input, condition: $condition) {
      id
      name
      description
      templateText
      templateBlocks {
        label
        value
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteJournalEntryTemplates = /* GraphQL */ `
  mutation DeleteJournalEntryTemplates(
    $input: DeleteJournalEntryTemplatesInput!
    $condition: ModelJournalEntryTemplatesConditionInput
  ) {
    deleteJournalEntryTemplates(input: $input, condition: $condition) {
      id
      name
      description
      templateText
      templateBlocks {
        label
        value
      }
      createdAt
      updatedAt
    }
  }
`;
export const createUserJournalEntryLog = /* GraphQL */ `
  mutation CreateUserJournalEntryLog(
    $input: CreateUserJournalEntryLogInput!
    $condition: ModelUserJournalEntryLogConditionInput
  ) {
    createUserJournalEntryLog(input: $input, condition: $condition) {
      userId
      entryTitle
      entryLogType
      entryLogTags {
        label
        value
      }
      isVisibleToCoach
      isVisibleToPublic
      entryText
      entryBlocks {
        label
        value
      }
      journalEntryTemplateId
      rawEntry
      createdAt
      updatedAt
    }
  }
`;
export const updateUserJournalEntryLog = /* GraphQL */ `
  mutation UpdateUserJournalEntryLog(
    $input: UpdateUserJournalEntryLogInput!
    $condition: ModelUserJournalEntryLogConditionInput
  ) {
    updateUserJournalEntryLog(input: $input, condition: $condition) {
      userId
      entryTitle
      entryLogType
      entryLogTags {
        label
        value
      }
      isVisibleToCoach
      isVisibleToPublic
      entryText
      entryBlocks {
        label
        value
      }
      journalEntryTemplateId
      rawEntry
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserJournalEntryLog = /* GraphQL */ `
  mutation DeleteUserJournalEntryLog(
    $input: DeleteUserJournalEntryLogInput!
    $condition: ModelUserJournalEntryLogConditionInput
  ) {
    deleteUserJournalEntryLog(input: $input, condition: $condition) {
      userId
      entryTitle
      entryLogType
      entryLogTags {
        label
        value
      }
      isVisibleToCoach
      isVisibleToPublic
      entryText
      entryBlocks {
        label
        value
      }
      journalEntryTemplateId
      rawEntry
      createdAt
      updatedAt
    }
  }
`;
export const createUserPlan = /* GraphQL */ `
  mutation CreateUserPlan(
    $input: CreateUserPlanInput!
    $condition: ModelUserPlanConditionInput
  ) {
    createUserPlan(input: $input, condition: $condition) {
      id
      userId
      planId
      plan {
        id
        planGroupId
        planGroup {
          id
          name
          startDate
          endDate
          trialPeriod
          createdAt
          active
          plans {
            nextToken
          }
          updatedAt
        }
        name
        description
        active
        defaultPrice
        defaultPlanPriceId
        discountsAllowed
        display
        isTrial
        upgradeable
        downgradeable
        features
        createdAt
        level
        pricing {
          items {
            planId
            slug
            default
            activationCodes
            downgradePricingIds
            upgradePricingIds
            price
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          coachingSessionsAllocated
          stripeProductId
        }
        updatedAt
      }
      planGroupId
      planGroup {
        id
        name
        startDate
        endDate
        trialPeriod
        createdAt
        active
        plans {
          items {
            id
            planGroupId
            name
            description
            active
            defaultPrice
            defaultPlanPriceId
            discountsAllowed
            display
            isTrial
            upgradeable
            downgradeable
            features
            createdAt
            level
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      planPricingSlug
      planPricing {
        planId
        plan {
          id
          planGroupId
          planGroup {
            id
            name
            startDate
            endDate
            trialPeriod
            createdAt
            active
            updatedAt
          }
          name
          description
          active
          defaultPrice
          defaultPlanPriceId
          discountsAllowed
          display
          isTrial
          upgradeable
          downgradeable
          features
          createdAt
          level
          pricing {
            nextToken
          }
          metadata {
            coachingSessionsAllocated
            stripeProductId
          }
          updatedAt
        }
        slug
        default
        activationCodes
        downgradePricingIds
        upgradePricingIds
        price
        metadata {
          stripePriceId
        }
        createdAt
        updatedAt
      }
      startDate
      endDate
      cancelled
      cancellationReason
      createdAt
      active
      metadata {
        stripeSubscriptionId
        stripeCustomerId
      }
      updatedAt
    }
  }
`;
export const updateUserPlan = /* GraphQL */ `
  mutation UpdateUserPlan(
    $input: UpdateUserPlanInput!
    $condition: ModelUserPlanConditionInput
  ) {
    updateUserPlan(input: $input, condition: $condition) {
      id
      userId
      planId
      plan {
        id
        planGroupId
        planGroup {
          id
          name
          startDate
          endDate
          trialPeriod
          createdAt
          active
          plans {
            nextToken
          }
          updatedAt
        }
        name
        description
        active
        defaultPrice
        defaultPlanPriceId
        discountsAllowed
        display
        isTrial
        upgradeable
        downgradeable
        features
        createdAt
        level
        pricing {
          items {
            planId
            slug
            default
            activationCodes
            downgradePricingIds
            upgradePricingIds
            price
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          coachingSessionsAllocated
          stripeProductId
        }
        updatedAt
      }
      planGroupId
      planGroup {
        id
        name
        startDate
        endDate
        trialPeriod
        createdAt
        active
        plans {
          items {
            id
            planGroupId
            name
            description
            active
            defaultPrice
            defaultPlanPriceId
            discountsAllowed
            display
            isTrial
            upgradeable
            downgradeable
            features
            createdAt
            level
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      planPricingSlug
      planPricing {
        planId
        plan {
          id
          planGroupId
          planGroup {
            id
            name
            startDate
            endDate
            trialPeriod
            createdAt
            active
            updatedAt
          }
          name
          description
          active
          defaultPrice
          defaultPlanPriceId
          discountsAllowed
          display
          isTrial
          upgradeable
          downgradeable
          features
          createdAt
          level
          pricing {
            nextToken
          }
          metadata {
            coachingSessionsAllocated
            stripeProductId
          }
          updatedAt
        }
        slug
        default
        activationCodes
        downgradePricingIds
        upgradePricingIds
        price
        metadata {
          stripePriceId
        }
        createdAt
        updatedAt
      }
      startDate
      endDate
      cancelled
      cancellationReason
      createdAt
      active
      metadata {
        stripeSubscriptionId
        stripeCustomerId
      }
      updatedAt
    }
  }
`;
export const deleteUserPlan = /* GraphQL */ `
  mutation DeleteUserPlan(
    $input: DeleteUserPlanInput!
    $condition: ModelUserPlanConditionInput
  ) {
    deleteUserPlan(input: $input, condition: $condition) {
      id
      userId
      planId
      plan {
        id
        planGroupId
        planGroup {
          id
          name
          startDate
          endDate
          trialPeriod
          createdAt
          active
          plans {
            nextToken
          }
          updatedAt
        }
        name
        description
        active
        defaultPrice
        defaultPlanPriceId
        discountsAllowed
        display
        isTrial
        upgradeable
        downgradeable
        features
        createdAt
        level
        pricing {
          items {
            planId
            slug
            default
            activationCodes
            downgradePricingIds
            upgradePricingIds
            price
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          coachingSessionsAllocated
          stripeProductId
        }
        updatedAt
      }
      planGroupId
      planGroup {
        id
        name
        startDate
        endDate
        trialPeriod
        createdAt
        active
        plans {
          items {
            id
            planGroupId
            name
            description
            active
            defaultPrice
            defaultPlanPriceId
            discountsAllowed
            display
            isTrial
            upgradeable
            downgradeable
            features
            createdAt
            level
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      planPricingSlug
      planPricing {
        planId
        plan {
          id
          planGroupId
          planGroup {
            id
            name
            startDate
            endDate
            trialPeriod
            createdAt
            active
            updatedAt
          }
          name
          description
          active
          defaultPrice
          defaultPlanPriceId
          discountsAllowed
          display
          isTrial
          upgradeable
          downgradeable
          features
          createdAt
          level
          pricing {
            nextToken
          }
          metadata {
            coachingSessionsAllocated
            stripeProductId
          }
          updatedAt
        }
        slug
        default
        activationCodes
        downgradePricingIds
        upgradePricingIds
        price
        metadata {
          stripePriceId
        }
        createdAt
        updatedAt
      }
      startDate
      endDate
      cancelled
      cancellationReason
      createdAt
      active
      metadata {
        stripeSubscriptionId
        stripeCustomerId
      }
      updatedAt
    }
  }
`;
export const createUserCoachingCredits = /* GraphQL */ `
  mutation CreateUserCoachingCredits(
    $input: CreateUserCoachingCreditsInput!
    $condition: ModelUserCoachingCreditsConditionInput
  ) {
    createUserCoachingCredits(input: $input, condition: $condition) {
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      yearMonth
      creditsAwarded
      creditsRemaining
      lastUsedTimestamp
      createdAt
      updatedAt
    }
  }
`;
export const updateUserCoachingCredits = /* GraphQL */ `
  mutation UpdateUserCoachingCredits(
    $input: UpdateUserCoachingCreditsInput!
    $condition: ModelUserCoachingCreditsConditionInput
  ) {
    updateUserCoachingCredits(input: $input, condition: $condition) {
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      yearMonth
      creditsAwarded
      creditsRemaining
      lastUsedTimestamp
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserCoachingCredits = /* GraphQL */ `
  mutation DeleteUserCoachingCredits(
    $input: DeleteUserCoachingCreditsInput!
    $condition: ModelUserCoachingCreditsConditionInput
  ) {
    deleteUserCoachingCredits(input: $input, condition: $condition) {
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      yearMonth
      creditsAwarded
      creditsRemaining
      lastUsedTimestamp
      createdAt
      updatedAt
    }
  }
`;
export const createUserCoachingCreditUsageLog = /* GraphQL */ `
  mutation CreateUserCoachingCreditUsageLog(
    $input: CreateUserCoachingCreditUsageLogInput!
    $condition: ModelUserCoachingCreditUsageLogConditionInput
  ) {
    createUserCoachingCreditUsageLog(input: $input, condition: $condition) {
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      memo
      timestamp
      id
      createdAt
      updatedAt
    }
  }
`;
export const updateUserCoachingCreditUsageLog = /* GraphQL */ `
  mutation UpdateUserCoachingCreditUsageLog(
    $input: UpdateUserCoachingCreditUsageLogInput!
    $condition: ModelUserCoachingCreditUsageLogConditionInput
  ) {
    updateUserCoachingCreditUsageLog(input: $input, condition: $condition) {
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      memo
      timestamp
      id
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserCoachingCreditUsageLog = /* GraphQL */ `
  mutation DeleteUserCoachingCreditUsageLog(
    $input: DeleteUserCoachingCreditUsageLogInput!
    $condition: ModelUserCoachingCreditUsageLogConditionInput
  ) {
    deleteUserCoachingCreditUsageLog(input: $input, condition: $condition) {
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      memo
      timestamp
      id
      createdAt
      updatedAt
    }
  }
`;
export const createUserFocusArea = /* GraphQL */ `
  mutation CreateUserFocusArea(
    $input: CreateUserFocusAreaInput!
    $condition: ModelUserFocusAreaConditionInput
  ) {
    createUserFocusArea(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      startDate
      endDate
      completed
      dateCompleted
      userFocusAreaGoals {
        items {
          id
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalId
          focusAreaGoal {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          userFocusAreaGoalHabits {
            nextToken
          }
          completed
          dateCompleted
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateUserFocusArea = /* GraphQL */ `
  mutation UpdateUserFocusArea(
    $input: UpdateUserFocusAreaInput!
    $condition: ModelUserFocusAreaConditionInput
  ) {
    updateUserFocusArea(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      startDate
      endDate
      completed
      dateCompleted
      userFocusAreaGoals {
        items {
          id
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalId
          focusAreaGoal {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          userFocusAreaGoalHabits {
            nextToken
          }
          completed
          dateCompleted
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserFocusArea = /* GraphQL */ `
  mutation DeleteUserFocusArea(
    $input: DeleteUserFocusAreaInput!
    $condition: ModelUserFocusAreaConditionInput
  ) {
    deleteUserFocusArea(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      startDate
      endDate
      completed
      dateCompleted
      userFocusAreaGoals {
        items {
          id
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalId
          focusAreaGoal {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          userFocusAreaGoalHabits {
            nextToken
          }
          completed
          dateCompleted
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createUserFocusAreaGoals = /* GraphQL */ `
  mutation CreateUserFocusAreaGoals(
    $input: CreateUserFocusAreaGoalsInput!
    $condition: ModelUserFocusAreaGoalsConditionInput
  ) {
    createUserFocusAreaGoals(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      focusAreaGoalId
      focusAreaGoal {
        id
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalHabits {
          items {
            id
            focusAreaId
            focusAreaGoalId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        name
        slug
        description
        createdAt
        updatedAt
      }
      userFocusAreaGoalHabits {
        items {
          id
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalId
          focusAreaGoal {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabitId
          focusAreaGoalHabit {
            id
            focusAreaId
            focusAreaGoalId
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabitLog {
            nextToken
          }
          createdAt
          completed
          dateCompleted
          updatedAt
        }
        nextToken
      }
      completed
      dateCompleted
      createdAt
      updatedAt
    }
  }
`;
export const updateUserFocusAreaGoals = /* GraphQL */ `
  mutation UpdateUserFocusAreaGoals(
    $input: UpdateUserFocusAreaGoalsInput!
    $condition: ModelUserFocusAreaGoalsConditionInput
  ) {
    updateUserFocusAreaGoals(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      focusAreaGoalId
      focusAreaGoal {
        id
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalHabits {
          items {
            id
            focusAreaId
            focusAreaGoalId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        name
        slug
        description
        createdAt
        updatedAt
      }
      userFocusAreaGoalHabits {
        items {
          id
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalId
          focusAreaGoal {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabitId
          focusAreaGoalHabit {
            id
            focusAreaId
            focusAreaGoalId
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabitLog {
            nextToken
          }
          createdAt
          completed
          dateCompleted
          updatedAt
        }
        nextToken
      }
      completed
      dateCompleted
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserFocusAreaGoals = /* GraphQL */ `
  mutation DeleteUserFocusAreaGoals(
    $input: DeleteUserFocusAreaGoalsInput!
    $condition: ModelUserFocusAreaGoalsConditionInput
  ) {
    deleteUserFocusAreaGoals(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      focusAreaGoalId
      focusAreaGoal {
        id
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalHabits {
          items {
            id
            focusAreaId
            focusAreaGoalId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        name
        slug
        description
        createdAt
        updatedAt
      }
      userFocusAreaGoalHabits {
        items {
          id
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalId
          focusAreaGoal {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabitId
          focusAreaGoalHabit {
            id
            focusAreaId
            focusAreaGoalId
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabitLog {
            nextToken
          }
          createdAt
          completed
          dateCompleted
          updatedAt
        }
        nextToken
      }
      completed
      dateCompleted
      createdAt
      updatedAt
    }
  }
`;
export const createUserFocusAreaGoalHabit = /* GraphQL */ `
  mutation CreateUserFocusAreaGoalHabit(
    $input: CreateUserFocusAreaGoalHabitInput!
    $condition: ModelUserFocusAreaGoalHabitConditionInput
  ) {
    createUserFocusAreaGoalHabit(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      focusAreaGoalId
      focusAreaGoal {
        id
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalHabits {
          items {
            id
            focusAreaId
            focusAreaGoalId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        name
        slug
        description
        createdAt
        updatedAt
      }
      focusAreaGoalHabitId
      focusAreaGoalHabit {
        id
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalId
        focusAreaGoal {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabits {
            nextToken
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        name
        slug
        description
        createdAt
        updatedAt
      }
      focusAreaGoalHabitLog {
        items {
          id
          userId
          userFocusAreaGoalHabitId
          year
          month
          week
          day
          note
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      completed
      dateCompleted
      updatedAt
    }
  }
`;
export const updateUserFocusAreaGoalHabit = /* GraphQL */ `
  mutation UpdateUserFocusAreaGoalHabit(
    $input: UpdateUserFocusAreaGoalHabitInput!
    $condition: ModelUserFocusAreaGoalHabitConditionInput
  ) {
    updateUserFocusAreaGoalHabit(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      focusAreaGoalId
      focusAreaGoal {
        id
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalHabits {
          items {
            id
            focusAreaId
            focusAreaGoalId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        name
        slug
        description
        createdAt
        updatedAt
      }
      focusAreaGoalHabitId
      focusAreaGoalHabit {
        id
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalId
        focusAreaGoal {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabits {
            nextToken
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        name
        slug
        description
        createdAt
        updatedAt
      }
      focusAreaGoalHabitLog {
        items {
          id
          userId
          userFocusAreaGoalHabitId
          year
          month
          week
          day
          note
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      completed
      dateCompleted
      updatedAt
    }
  }
`;
export const deleteUserFocusAreaGoalHabit = /* GraphQL */ `
  mutation DeleteUserFocusAreaGoalHabit(
    $input: DeleteUserFocusAreaGoalHabitInput!
    $condition: ModelUserFocusAreaGoalHabitConditionInput
  ) {
    deleteUserFocusAreaGoalHabit(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      focusAreaGoalId
      focusAreaGoal {
        id
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalHabits {
          items {
            id
            focusAreaId
            focusAreaGoalId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        name
        slug
        description
        createdAt
        updatedAt
      }
      focusAreaGoalHabitId
      focusAreaGoalHabit {
        id
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalId
        focusAreaGoal {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabits {
            nextToken
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        name
        slug
        description
        createdAt
        updatedAt
      }
      focusAreaGoalHabitLog {
        items {
          id
          userId
          userFocusAreaGoalHabitId
          year
          month
          week
          day
          note
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      completed
      dateCompleted
      updatedAt
    }
  }
`;
export const createUserFocusAreaGoalHabitLog = /* GraphQL */ `
  mutation CreateUserFocusAreaGoalHabitLog(
    $input: CreateUserFocusAreaGoalHabitLogInput!
    $condition: ModelUserFocusAreaGoalHabitLogConditionInput
  ) {
    createUserFocusAreaGoalHabitLog(input: $input, condition: $condition) {
      id
      userId
      userFocusAreaGoalHabitId
      year
      month
      week
      day
      note
      createdAt
      updatedAt
    }
  }
`;
export const updateUserFocusAreaGoalHabitLog = /* GraphQL */ `
  mutation UpdateUserFocusAreaGoalHabitLog(
    $input: UpdateUserFocusAreaGoalHabitLogInput!
    $condition: ModelUserFocusAreaGoalHabitLogConditionInput
  ) {
    updateUserFocusAreaGoalHabitLog(input: $input, condition: $condition) {
      id
      userId
      userFocusAreaGoalHabitId
      year
      month
      week
      day
      note
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserFocusAreaGoalHabitLog = /* GraphQL */ `
  mutation DeleteUserFocusAreaGoalHabitLog(
    $input: DeleteUserFocusAreaGoalHabitLogInput!
    $condition: ModelUserFocusAreaGoalHabitLogConditionInput
  ) {
    deleteUserFocusAreaGoalHabitLog(input: $input, condition: $condition) {
      id
      userId
      userFocusAreaGoalHabitId
      year
      month
      week
      day
      note
      createdAt
      updatedAt
    }
  }
`;
export const createUserAssessmentLog = /* GraphQL */ `
  mutation CreateUserAssessmentLog(
    $input: CreateUserAssessmentLogInput!
    $condition: ModelUserAssessmentLogConditionInput
  ) {
    createUserAssessmentLog(input: $input, condition: $condition) {
      id
      createdAt
      userId
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      assessment
      score
      maxScore
      userNotified
      coachReviewed
      updatedAt
    }
  }
`;
export const updateUserAssessmentLog = /* GraphQL */ `
  mutation UpdateUserAssessmentLog(
    $input: UpdateUserAssessmentLogInput!
    $condition: ModelUserAssessmentLogConditionInput
  ) {
    updateUserAssessmentLog(input: $input, condition: $condition) {
      id
      createdAt
      userId
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      assessment
      score
      maxScore
      userNotified
      coachReviewed
      updatedAt
    }
  }
`;
export const deleteUserAssessmentLog = /* GraphQL */ `
  mutation DeleteUserAssessmentLog(
    $input: DeleteUserAssessmentLogInput!
    $condition: ModelUserAssessmentLogConditionInput
  ) {
    deleteUserAssessmentLog(input: $input, condition: $condition) {
      id
      createdAt
      userId
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      assessment
      score
      maxScore
      userNotified
      coachReviewed
      updatedAt
    }
  }
`;
export const createUserLessons = /* GraphQL */ `
  mutation CreateUserLessons(
    $input: CreateUserLessonsInput!
    $condition: ModelUserLessonsConditionInput
  ) {
    createUserLessons(input: $input, condition: $condition) {
      id
      userId
      lessonId
      lesson {
        id
        programId
        program {
          id
          name
          description
          level
          lessons {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        name
        order
        durationInMins
        description
        transcript
        focusAreas {
          items {
            lessonId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        tags
        lessonType
        metadata {
          videoUrl
          videoStreamUrl
          videoExternalId
          videoDistributionPage
          formUrl
          formExternalId
        }
        coverImageUrl
        isPremium
        active
        createdAt
        updatedAt
      }
      startTimestamp
      completedTimestamp
      lastViewedTimestamp
      completed
      createdAt
      updatedAt
    }
  }
`;
export const updateUserLessons = /* GraphQL */ `
  mutation UpdateUserLessons(
    $input: UpdateUserLessonsInput!
    $condition: ModelUserLessonsConditionInput
  ) {
    updateUserLessons(input: $input, condition: $condition) {
      id
      userId
      lessonId
      lesson {
        id
        programId
        program {
          id
          name
          description
          level
          lessons {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        name
        order
        durationInMins
        description
        transcript
        focusAreas {
          items {
            lessonId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        tags
        lessonType
        metadata {
          videoUrl
          videoStreamUrl
          videoExternalId
          videoDistributionPage
          formUrl
          formExternalId
        }
        coverImageUrl
        isPremium
        active
        createdAt
        updatedAt
      }
      startTimestamp
      completedTimestamp
      lastViewedTimestamp
      completed
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserLessons = /* GraphQL */ `
  mutation DeleteUserLessons(
    $input: DeleteUserLessonsInput!
    $condition: ModelUserLessonsConditionInput
  ) {
    deleteUserLessons(input: $input, condition: $condition) {
      id
      userId
      lessonId
      lesson {
        id
        programId
        program {
          id
          name
          description
          level
          lessons {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        name
        order
        durationInMins
        description
        transcript
        focusAreas {
          items {
            lessonId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        tags
        lessonType
        metadata {
          videoUrl
          videoStreamUrl
          videoExternalId
          videoDistributionPage
          formUrl
          formExternalId
        }
        coverImageUrl
        isPremium
        active
        createdAt
        updatedAt
      }
      startTimestamp
      completedTimestamp
      lastViewedTimestamp
      completed
      createdAt
      updatedAt
    }
  }
`;
export const createUserGrowthPathItem = /* GraphQL */ `
  mutation CreateUserGrowthPathItem(
    $input: CreateUserGrowthPathItemInput!
    $condition: ModelUserGrowthPathItemConditionInput
  ) {
    createUserGrowthPathItem(input: $input, condition: $condition) {
      id
      growthPathItemId
      growthPathItem {
        id
        type
        title
        subtitle
        avatarUrl
        description
        categoryName
        categoryId
        estimatedCompletionTimeInMins
        actionTitle
        actionDestination
        actionPayload
        createdAt
        expirationDate
        lessonId
        lesson {
          id
          programId
          program {
            id
            name
            description
            level
            active
            createdAt
            updatedAt
          }
          name
          order
          durationInMins
          description
          transcript
          focusAreas {
            nextToken
          }
          tags
          lessonType
          metadata {
            videoUrl
            videoStreamUrl
            videoExternalId
            videoDistributionPage
            formUrl
            formExternalId
          }
          coverImageUrl
          isPremium
          active
          createdAt
          updatedAt
        }
        tags
        isArchived
        updatedAt
      }
      userId
      order
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      dateTimeAdded
      completed
      dismissed
      completedTimestamp
      expirationDate
      locked
      hidden
      isScheduled
      visibleDate
      visibleTimestamp
      growthPathJourneyId
      growthPathJourneyStep
      growthPathJourney {
        id
        title
        description
        growthPathItems {
          step
          growthPathItemId
          rules {
            ruleType
            dependencyGrowthPathItemId
            scheduleDaysFromNow
          }
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        active
        createdAt
        updatedAt
      }
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      source
      lastActivityTimestamp
      dependsOnGrowthPathItems
      createdAt
      updatedAt
    }
  }
`;
export const updateUserGrowthPathItem = /* GraphQL */ `
  mutation UpdateUserGrowthPathItem(
    $input: UpdateUserGrowthPathItemInput!
    $condition: ModelUserGrowthPathItemConditionInput
  ) {
    updateUserGrowthPathItem(input: $input, condition: $condition) {
      id
      growthPathItemId
      growthPathItem {
        id
        type
        title
        subtitle
        avatarUrl
        description
        categoryName
        categoryId
        estimatedCompletionTimeInMins
        actionTitle
        actionDestination
        actionPayload
        createdAt
        expirationDate
        lessonId
        lesson {
          id
          programId
          program {
            id
            name
            description
            level
            active
            createdAt
            updatedAt
          }
          name
          order
          durationInMins
          description
          transcript
          focusAreas {
            nextToken
          }
          tags
          lessonType
          metadata {
            videoUrl
            videoStreamUrl
            videoExternalId
            videoDistributionPage
            formUrl
            formExternalId
          }
          coverImageUrl
          isPremium
          active
          createdAt
          updatedAt
        }
        tags
        isArchived
        updatedAt
      }
      userId
      order
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      dateTimeAdded
      completed
      dismissed
      completedTimestamp
      expirationDate
      locked
      hidden
      isScheduled
      visibleDate
      visibleTimestamp
      growthPathJourneyId
      growthPathJourneyStep
      growthPathJourney {
        id
        title
        description
        growthPathItems {
          step
          growthPathItemId
          rules {
            ruleType
            dependencyGrowthPathItemId
            scheduleDaysFromNow
          }
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        active
        createdAt
        updatedAt
      }
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      source
      lastActivityTimestamp
      dependsOnGrowthPathItems
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserGrowthPathItem = /* GraphQL */ `
  mutation DeleteUserGrowthPathItem(
    $input: DeleteUserGrowthPathItemInput!
    $condition: ModelUserGrowthPathItemConditionInput
  ) {
    deleteUserGrowthPathItem(input: $input, condition: $condition) {
      id
      growthPathItemId
      growthPathItem {
        id
        type
        title
        subtitle
        avatarUrl
        description
        categoryName
        categoryId
        estimatedCompletionTimeInMins
        actionTitle
        actionDestination
        actionPayload
        createdAt
        expirationDate
        lessonId
        lesson {
          id
          programId
          program {
            id
            name
            description
            level
            active
            createdAt
            updatedAt
          }
          name
          order
          durationInMins
          description
          transcript
          focusAreas {
            nextToken
          }
          tags
          lessonType
          metadata {
            videoUrl
            videoStreamUrl
            videoExternalId
            videoDistributionPage
            formUrl
            formExternalId
          }
          coverImageUrl
          isPremium
          active
          createdAt
          updatedAt
        }
        tags
        isArchived
        updatedAt
      }
      userId
      order
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      dateTimeAdded
      completed
      dismissed
      completedTimestamp
      expirationDate
      locked
      hidden
      isScheduled
      visibleDate
      visibleTimestamp
      growthPathJourneyId
      growthPathJourneyStep
      growthPathJourney {
        id
        title
        description
        growthPathItems {
          step
          growthPathItemId
          rules {
            ruleType
            dependencyGrowthPathItemId
            scheduleDaysFromNow
          }
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        active
        createdAt
        updatedAt
      }
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      source
      lastActivityTimestamp
      dependsOnGrowthPathItems
      createdAt
      updatedAt
    }
  }
`;
export const createUserGrowthPathJourney = /* GraphQL */ `
  mutation CreateUserGrowthPathJourney(
    $input: CreateUserGrowthPathJourneyInput!
    $condition: ModelUserGrowthPathJourneyConditionInput
  ) {
    createUserGrowthPathJourney(input: $input, condition: $condition) {
      userId
      growthPathJourneyId
      growthPathJourney {
        id
        title
        description
        growthPathItems {
          step
          growthPathItemId
          rules {
            ruleType
            dependencyGrowthPathItemId
            scheduleDaysFromNow
          }
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        active
        createdAt
        updatedAt
      }
      completionLog {
        growthPathItemId
        completionTimestamp
      }
      lastActivityTimestamp
      active
      id
      createdAt
      updatedAt
    }
  }
`;
export const updateUserGrowthPathJourney = /* GraphQL */ `
  mutation UpdateUserGrowthPathJourney(
    $input: UpdateUserGrowthPathJourneyInput!
    $condition: ModelUserGrowthPathJourneyConditionInput
  ) {
    updateUserGrowthPathJourney(input: $input, condition: $condition) {
      userId
      growthPathJourneyId
      growthPathJourney {
        id
        title
        description
        growthPathItems {
          step
          growthPathItemId
          rules {
            ruleType
            dependencyGrowthPathItemId
            scheduleDaysFromNow
          }
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        active
        createdAt
        updatedAt
      }
      completionLog {
        growthPathItemId
        completionTimestamp
      }
      lastActivityTimestamp
      active
      id
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserGrowthPathJourney = /* GraphQL */ `
  mutation DeleteUserGrowthPathJourney(
    $input: DeleteUserGrowthPathJourneyInput!
    $condition: ModelUserGrowthPathJourneyConditionInput
  ) {
    deleteUserGrowthPathJourney(input: $input, condition: $condition) {
      userId
      growthPathJourneyId
      growthPathJourney {
        id
        title
        description
        growthPathItems {
          step
          growthPathItemId
          rules {
            ruleType
            dependencyGrowthPathItemId
            scheduleDaysFromNow
          }
        }
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        active
        createdAt
        updatedAt
      }
      completionLog {
        growthPathItemId
        completionTimestamp
      }
      lastActivityTimestamp
      active
      id
      createdAt
      updatedAt
    }
  }
`;
export const createGrowthPathJourney = /* GraphQL */ `
  mutation CreateGrowthPathJourney(
    $input: CreateGrowthPathJourneyInput!
    $condition: ModelGrowthPathJourneyConditionInput
  ) {
    createGrowthPathJourney(input: $input, condition: $condition) {
      id
      title
      description
      growthPathItems {
        step
        growthPathItemId
        rules {
          ruleType
          dependencyGrowthPathItemId
          scheduleDaysFromNow
        }
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      active
      createdAt
      updatedAt
    }
  }
`;
export const updateGrowthPathJourney = /* GraphQL */ `
  mutation UpdateGrowthPathJourney(
    $input: UpdateGrowthPathJourneyInput!
    $condition: ModelGrowthPathJourneyConditionInput
  ) {
    updateGrowthPathJourney(input: $input, condition: $condition) {
      id
      title
      description
      growthPathItems {
        step
        growthPathItemId
        rules {
          ruleType
          dependencyGrowthPathItemId
          scheduleDaysFromNow
        }
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      active
      createdAt
      updatedAt
    }
  }
`;
export const deleteGrowthPathJourney = /* GraphQL */ `
  mutation DeleteGrowthPathJourney(
    $input: DeleteGrowthPathJourneyInput!
    $condition: ModelGrowthPathJourneyConditionInput
  ) {
    deleteGrowthPathJourney(input: $input, condition: $condition) {
      id
      title
      description
      growthPathItems {
        step
        growthPathItemId
        rules {
          ruleType
          dependencyGrowthPathItemId
          scheduleDaysFromNow
        }
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      active
      createdAt
      updatedAt
    }
  }
`;
export const createUserAppointments = /* GraphQL */ `
  mutation CreateUserAppointments(
    $input: CreateUserAppointmentsInput!
    $condition: ModelUserAppointmentsConditionInput
  ) {
    createUserAppointments(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      appointmentStartTime
      appointmentEndTime
      appointmentDurationMins
      appointmentTimezone
      appointmentType
      cancelled
      cancelDate
      cancelReason
      cancelNote
      metadata {
        acuityAppointmentId
        acuityAppointmentTypeId
        acuityConfirmationPageUrl
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateUserAppointments = /* GraphQL */ `
  mutation UpdateUserAppointments(
    $input: UpdateUserAppointmentsInput!
    $condition: ModelUserAppointmentsConditionInput
  ) {
    updateUserAppointments(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      appointmentStartTime
      appointmentEndTime
      appointmentDurationMins
      appointmentTimezone
      appointmentType
      cancelled
      cancelDate
      cancelReason
      cancelNote
      metadata {
        acuityAppointmentId
        acuityAppointmentTypeId
        acuityConfirmationPageUrl
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserAppointments = /* GraphQL */ `
  mutation DeleteUserAppointments(
    $input: DeleteUserAppointmentsInput!
    $condition: ModelUserAppointmentsConditionInput
  ) {
    deleteUserAppointments(input: $input, condition: $condition) {
      id
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      appointmentStartTime
      appointmentEndTime
      appointmentDurationMins
      appointmentTimezone
      appointmentType
      cancelled
      cancelDate
      cancelReason
      cancelNote
      metadata {
        acuityAppointmentId
        acuityAppointmentTypeId
        acuityConfirmationPageUrl
      }
      createdAt
      updatedAt
    }
  }
`;
export const createUserNotification = /* GraphQL */ `
  mutation CreateUserNotification(
    $input: CreateUserNotificationInput!
    $condition: ModelUserNotificationConditionInput
  ) {
    createUserNotification(input: $input, condition: $condition) {
      id
      userId
      notificationType
      notificationMessage
      notificationTitle
      notificationExpirationDate
      notificationRead
      createdAt
      updatedAt
    }
  }
`;
export const updateUserNotification = /* GraphQL */ `
  mutation UpdateUserNotification(
    $input: UpdateUserNotificationInput!
    $condition: ModelUserNotificationConditionInput
  ) {
    updateUserNotification(input: $input, condition: $condition) {
      id
      userId
      notificationType
      notificationMessage
      notificationTitle
      notificationExpirationDate
      notificationRead
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserNotification = /* GraphQL */ `
  mutation DeleteUserNotification(
    $input: DeleteUserNotificationInput!
    $condition: ModelUserNotificationConditionInput
  ) {
    deleteUserNotification(input: $input, condition: $condition) {
      id
      userId
      notificationType
      notificationMessage
      notificationTitle
      notificationExpirationDate
      notificationRead
      createdAt
      updatedAt
    }
  }
`;
export const createCoach = /* GraphQL */ `
  mutation CreateCoach(
    $input: CreateCoachInput!
    $condition: ModelCoachConditionInput
  ) {
    createCoach(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      title
      coachType
      avatarUrl
      description
      metadata {
        introVideoUrl
        gcalId
        calendlyId
        acuityCalendarId
        acuityUserId
        acuityKey
        acuityIssAppointmentId
        acuityRegularAppointmentId
        streamChatId
        slackId
        lastCoachNote
        lastChatMessage
      }
      focusAreas {
        items {
          id
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      members {
        items {
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          isPrimary
          active
          coachingStartDate
          coachingEndDate
          ratings {
            nextToken
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      active
      createdAt
      updatedAt
    }
  }
`;
export const updateCoach = /* GraphQL */ `
  mutation UpdateCoach(
    $input: UpdateCoachInput!
    $condition: ModelCoachConditionInput
  ) {
    updateCoach(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      title
      coachType
      avatarUrl
      description
      metadata {
        introVideoUrl
        gcalId
        calendlyId
        acuityCalendarId
        acuityUserId
        acuityKey
        acuityIssAppointmentId
        acuityRegularAppointmentId
        streamChatId
        slackId
        lastCoachNote
        lastChatMessage
      }
      focusAreas {
        items {
          id
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      members {
        items {
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          isPrimary
          active
          coachingStartDate
          coachingEndDate
          ratings {
            nextToken
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      active
      createdAt
      updatedAt
    }
  }
`;
export const deleteCoach = /* GraphQL */ `
  mutation DeleteCoach(
    $input: DeleteCoachInput!
    $condition: ModelCoachConditionInput
  ) {
    deleteCoach(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      title
      coachType
      avatarUrl
      description
      metadata {
        introVideoUrl
        gcalId
        calendlyId
        acuityCalendarId
        acuityUserId
        acuityKey
        acuityIssAppointmentId
        acuityRegularAppointmentId
        streamChatId
        slackId
        lastCoachNote
        lastChatMessage
      }
      focusAreas {
        items {
          id
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      members {
        items {
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          isPrimary
          active
          coachingStartDate
          coachingEndDate
          ratings {
            nextToken
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      active
      createdAt
      updatedAt
    }
  }
`;
export const createCoachFocusArea = /* GraphQL */ `
  mutation CreateCoachFocusArea(
    $input: CreateCoachFocusAreaInput!
    $condition: ModelCoachFocusAreaConditionInput
  ) {
    createCoachFocusArea(input: $input, condition: $condition) {
      id
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateCoachFocusArea = /* GraphQL */ `
  mutation UpdateCoachFocusArea(
    $input: UpdateCoachFocusAreaInput!
    $condition: ModelCoachFocusAreaConditionInput
  ) {
    updateCoachFocusArea(input: $input, condition: $condition) {
      id
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteCoachFocusArea = /* GraphQL */ `
  mutation DeleteCoachFocusArea(
    $input: DeleteCoachFocusAreaInput!
    $condition: ModelCoachFocusAreaConditionInput
  ) {
    deleteCoachFocusArea(input: $input, condition: $condition) {
      id
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createCoachUserNotification = /* GraphQL */ `
  mutation CreateCoachUserNotification(
    $input: CreateCoachUserNotificationInput!
    $condition: ModelCoachUserNotificationConditionInput
  ) {
    createCoachUserNotification(input: $input, condition: $condition) {
      id
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      title
      read
      readTimestamp
      notificationType
      rawPayload
      createdAt
      updatedAt
    }
  }
`;
export const updateCoachUserNotification = /* GraphQL */ `
  mutation UpdateCoachUserNotification(
    $input: UpdateCoachUserNotificationInput!
    $condition: ModelCoachUserNotificationConditionInput
  ) {
    updateCoachUserNotification(input: $input, condition: $condition) {
      id
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      title
      read
      readTimestamp
      notificationType
      rawPayload
      createdAt
      updatedAt
    }
  }
`;
export const deleteCoachUserNotification = /* GraphQL */ `
  mutation DeleteCoachUserNotification(
    $input: DeleteCoachUserNotificationInput!
    $condition: ModelCoachUserNotificationConditionInput
  ) {
    deleteCoachUserNotification(input: $input, condition: $condition) {
      id
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      title
      read
      readTimestamp
      notificationType
      rawPayload
      createdAt
      updatedAt
    }
  }
`;
export const createGrowthPathItem = /* GraphQL */ `
  mutation CreateGrowthPathItem(
    $input: CreateGrowthPathItemInput!
    $condition: ModelGrowthPathItemConditionInput
  ) {
    createGrowthPathItem(input: $input, condition: $condition) {
      id
      type
      title
      subtitle
      avatarUrl
      description
      categoryName
      categoryId
      estimatedCompletionTimeInMins
      actionTitle
      actionDestination
      actionPayload
      createdAt
      expirationDate
      lessonId
      lesson {
        id
        programId
        program {
          id
          name
          description
          level
          lessons {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        name
        order
        durationInMins
        description
        transcript
        focusAreas {
          items {
            lessonId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        tags
        lessonType
        metadata {
          videoUrl
          videoStreamUrl
          videoExternalId
          videoDistributionPage
          formUrl
          formExternalId
        }
        coverImageUrl
        isPremium
        active
        createdAt
        updatedAt
      }
      tags
      isArchived
      updatedAt
    }
  }
`;
export const updateGrowthPathItem = /* GraphQL */ `
  mutation UpdateGrowthPathItem(
    $input: UpdateGrowthPathItemInput!
    $condition: ModelGrowthPathItemConditionInput
  ) {
    updateGrowthPathItem(input: $input, condition: $condition) {
      id
      type
      title
      subtitle
      avatarUrl
      description
      categoryName
      categoryId
      estimatedCompletionTimeInMins
      actionTitle
      actionDestination
      actionPayload
      createdAt
      expirationDate
      lessonId
      lesson {
        id
        programId
        program {
          id
          name
          description
          level
          lessons {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        name
        order
        durationInMins
        description
        transcript
        focusAreas {
          items {
            lessonId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        tags
        lessonType
        metadata {
          videoUrl
          videoStreamUrl
          videoExternalId
          videoDistributionPage
          formUrl
          formExternalId
        }
        coverImageUrl
        isPremium
        active
        createdAt
        updatedAt
      }
      tags
      isArchived
      updatedAt
    }
  }
`;
export const deleteGrowthPathItem = /* GraphQL */ `
  mutation DeleteGrowthPathItem(
    $input: DeleteGrowthPathItemInput!
    $condition: ModelGrowthPathItemConditionInput
  ) {
    deleteGrowthPathItem(input: $input, condition: $condition) {
      id
      type
      title
      subtitle
      avatarUrl
      description
      categoryName
      categoryId
      estimatedCompletionTimeInMins
      actionTitle
      actionDestination
      actionPayload
      createdAt
      expirationDate
      lessonId
      lesson {
        id
        programId
        program {
          id
          name
          description
          level
          lessons {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        name
        order
        durationInMins
        description
        transcript
        focusAreas {
          items {
            lessonId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        tags
        lessonType
        metadata {
          videoUrl
          videoStreamUrl
          videoExternalId
          videoDistributionPage
          formUrl
          formExternalId
        }
        coverImageUrl
        isPremium
        active
        createdAt
        updatedAt
      }
      tags
      isArchived
      updatedAt
    }
  }
`;
export const createTopicTags = /* GraphQL */ `
  mutation CreateTopicTags(
    $input: CreateTopicTagsInput!
    $condition: ModelTopicTagsConditionInput
  ) {
    createTopicTags(input: $input, condition: $condition) {
      slug
      name
      description
      createdAt
      updatedAt
    }
  }
`;
export const updateTopicTags = /* GraphQL */ `
  mutation UpdateTopicTags(
    $input: UpdateTopicTagsInput!
    $condition: ModelTopicTagsConditionInput
  ) {
    updateTopicTags(input: $input, condition: $condition) {
      slug
      name
      description
      createdAt
      updatedAt
    }
  }
`;
export const deleteTopicTags = /* GraphQL */ `
  mutation DeleteTopicTags(
    $input: DeleteTopicTagsInput!
    $condition: ModelTopicTagsConditionInput
  ) {
    deleteTopicTags(input: $input, condition: $condition) {
      slug
      name
      description
      createdAt
      updatedAt
    }
  }
`;
export const createFocusArea = /* GraphQL */ `
  mutation CreateFocusArea(
    $input: CreateFocusAreaInput!
    $condition: ModelFocusAreaConditionInput
  ) {
    createFocusArea(input: $input, condition: $condition) {
      id
      name
      slug
      description
      focusAreaGoals {
        items {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabits {
            nextToken
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateFocusArea = /* GraphQL */ `
  mutation UpdateFocusArea(
    $input: UpdateFocusAreaInput!
    $condition: ModelFocusAreaConditionInput
  ) {
    updateFocusArea(input: $input, condition: $condition) {
      id
      name
      slug
      description
      focusAreaGoals {
        items {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabits {
            nextToken
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteFocusArea = /* GraphQL */ `
  mutation DeleteFocusArea(
    $input: DeleteFocusAreaInput!
    $condition: ModelFocusAreaConditionInput
  ) {
    deleteFocusArea(input: $input, condition: $condition) {
      id
      name
      slug
      description
      focusAreaGoals {
        items {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalHabits {
            nextToken
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createFocusAreaGoal = /* GraphQL */ `
  mutation CreateFocusAreaGoal(
    $input: CreateFocusAreaGoalInput!
    $condition: ModelFocusAreaGoalConditionInput
  ) {
    createFocusAreaGoal(input: $input, condition: $condition) {
      id
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      focusAreaGoalHabits {
        items {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalId
          focusAreaGoal {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        nextToken
      }
      name
      slug
      description
      createdAt
      updatedAt
    }
  }
`;
export const updateFocusAreaGoal = /* GraphQL */ `
  mutation UpdateFocusAreaGoal(
    $input: UpdateFocusAreaGoalInput!
    $condition: ModelFocusAreaGoalConditionInput
  ) {
    updateFocusAreaGoal(input: $input, condition: $condition) {
      id
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      focusAreaGoalHabits {
        items {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalId
          focusAreaGoal {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        nextToken
      }
      name
      slug
      description
      createdAt
      updatedAt
    }
  }
`;
export const deleteFocusAreaGoal = /* GraphQL */ `
  mutation DeleteFocusAreaGoal(
    $input: DeleteFocusAreaGoalInput!
    $condition: ModelFocusAreaGoalConditionInput
  ) {
    deleteFocusAreaGoal(input: $input, condition: $condition) {
      id
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      focusAreaGoalHabits {
        items {
          id
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          focusAreaGoalId
          focusAreaGoal {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          name
          slug
          description
          createdAt
          updatedAt
        }
        nextToken
      }
      name
      slug
      description
      createdAt
      updatedAt
    }
  }
`;
export const createFocusAreaGoalHabits = /* GraphQL */ `
  mutation CreateFocusAreaGoalHabits(
    $input: CreateFocusAreaGoalHabitsInput!
    $condition: ModelFocusAreaGoalHabitsConditionInput
  ) {
    createFocusAreaGoalHabits(input: $input, condition: $condition) {
      id
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      focusAreaGoalId
      focusAreaGoal {
        id
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalHabits {
          items {
            id
            focusAreaId
            focusAreaGoalId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        name
        slug
        description
        createdAt
        updatedAt
      }
      name
      slug
      description
      createdAt
      updatedAt
    }
  }
`;
export const updateFocusAreaGoalHabits = /* GraphQL */ `
  mutation UpdateFocusAreaGoalHabits(
    $input: UpdateFocusAreaGoalHabitsInput!
    $condition: ModelFocusAreaGoalHabitsConditionInput
  ) {
    updateFocusAreaGoalHabits(input: $input, condition: $condition) {
      id
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      focusAreaGoalId
      focusAreaGoal {
        id
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalHabits {
          items {
            id
            focusAreaId
            focusAreaGoalId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        name
        slug
        description
        createdAt
        updatedAt
      }
      name
      slug
      description
      createdAt
      updatedAt
    }
  }
`;
export const deleteFocusAreaGoalHabits = /* GraphQL */ `
  mutation DeleteFocusAreaGoalHabits(
    $input: DeleteFocusAreaGoalHabitsInput!
    $condition: ModelFocusAreaGoalHabitsConditionInput
  ) {
    deleteFocusAreaGoalHabits(input: $input, condition: $condition) {
      id
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      focusAreaGoalId
      focusAreaGoal {
        id
        focusAreaId
        focusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        focusAreaGoalHabits {
          items {
            id
            focusAreaId
            focusAreaGoalId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        name
        slug
        description
        createdAt
        updatedAt
      }
      name
      slug
      description
      createdAt
      updatedAt
    }
  }
`;
export const createProgram = /* GraphQL */ `
  mutation CreateProgram(
    $input: CreateProgramInput!
    $condition: ModelProgramConditionInput
  ) {
    createProgram(input: $input, condition: $condition) {
      id
      name
      description
      level
      lessons {
        items {
          id
          programId
          program {
            id
            name
            description
            level
            active
            createdAt
            updatedAt
          }
          name
          order
          durationInMins
          description
          transcript
          focusAreas {
            nextToken
          }
          tags
          lessonType
          metadata {
            videoUrl
            videoStreamUrl
            videoExternalId
            videoDistributionPage
            formUrl
            formExternalId
          }
          coverImageUrl
          isPremium
          active
          createdAt
          updatedAt
        }
        nextToken
      }
      active
      createdAt
      updatedAt
    }
  }
`;
export const updateProgram = /* GraphQL */ `
  mutation UpdateProgram(
    $input: UpdateProgramInput!
    $condition: ModelProgramConditionInput
  ) {
    updateProgram(input: $input, condition: $condition) {
      id
      name
      description
      level
      lessons {
        items {
          id
          programId
          program {
            id
            name
            description
            level
            active
            createdAt
            updatedAt
          }
          name
          order
          durationInMins
          description
          transcript
          focusAreas {
            nextToken
          }
          tags
          lessonType
          metadata {
            videoUrl
            videoStreamUrl
            videoExternalId
            videoDistributionPage
            formUrl
            formExternalId
          }
          coverImageUrl
          isPremium
          active
          createdAt
          updatedAt
        }
        nextToken
      }
      active
      createdAt
      updatedAt
    }
  }
`;
export const deleteProgram = /* GraphQL */ `
  mutation DeleteProgram(
    $input: DeleteProgramInput!
    $condition: ModelProgramConditionInput
  ) {
    deleteProgram(input: $input, condition: $condition) {
      id
      name
      description
      level
      lessons {
        items {
          id
          programId
          program {
            id
            name
            description
            level
            active
            createdAt
            updatedAt
          }
          name
          order
          durationInMins
          description
          transcript
          focusAreas {
            nextToken
          }
          tags
          lessonType
          metadata {
            videoUrl
            videoStreamUrl
            videoExternalId
            videoDistributionPage
            formUrl
            formExternalId
          }
          coverImageUrl
          isPremium
          active
          createdAt
          updatedAt
        }
        nextToken
      }
      active
      createdAt
      updatedAt
    }
  }
`;
export const createLesson = /* GraphQL */ `
  mutation CreateLesson(
    $input: CreateLessonInput!
    $condition: ModelLessonConditionInput
  ) {
    createLesson(input: $input, condition: $condition) {
      id
      programId
      program {
        id
        name
        description
        level
        lessons {
          items {
            id
            programId
            name
            order
            durationInMins
            description
            transcript
            tags
            lessonType
            coverImageUrl
            isPremium
            active
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      name
      order
      durationInMins
      description
      transcript
      focusAreas {
        items {
          lessonId
          lesson {
            id
            programId
            name
            order
            durationInMins
            description
            transcript
            tags
            lessonType
            coverImageUrl
            isPremium
            active
            createdAt
            updatedAt
          }
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      tags
      lessonType
      metadata {
        videoUrl
        videoStreamUrl
        videoExternalId
        videoDistributionPage
        formUrl
        formExternalId
      }
      coverImageUrl
      isPremium
      active
      createdAt
      updatedAt
    }
  }
`;
export const updateLesson = /* GraphQL */ `
  mutation UpdateLesson(
    $input: UpdateLessonInput!
    $condition: ModelLessonConditionInput
  ) {
    updateLesson(input: $input, condition: $condition) {
      id
      programId
      program {
        id
        name
        description
        level
        lessons {
          items {
            id
            programId
            name
            order
            durationInMins
            description
            transcript
            tags
            lessonType
            coverImageUrl
            isPremium
            active
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      name
      order
      durationInMins
      description
      transcript
      focusAreas {
        items {
          lessonId
          lesson {
            id
            programId
            name
            order
            durationInMins
            description
            transcript
            tags
            lessonType
            coverImageUrl
            isPremium
            active
            createdAt
            updatedAt
          }
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      tags
      lessonType
      metadata {
        videoUrl
        videoStreamUrl
        videoExternalId
        videoDistributionPage
        formUrl
        formExternalId
      }
      coverImageUrl
      isPremium
      active
      createdAt
      updatedAt
    }
  }
`;
export const deleteLesson = /* GraphQL */ `
  mutation DeleteLesson(
    $input: DeleteLessonInput!
    $condition: ModelLessonConditionInput
  ) {
    deleteLesson(input: $input, condition: $condition) {
      id
      programId
      program {
        id
        name
        description
        level
        lessons {
          items {
            id
            programId
            name
            order
            durationInMins
            description
            transcript
            tags
            lessonType
            coverImageUrl
            isPremium
            active
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      name
      order
      durationInMins
      description
      transcript
      focusAreas {
        items {
          lessonId
          lesson {
            id
            programId
            name
            order
            durationInMins
            description
            transcript
            tags
            lessonType
            coverImageUrl
            isPremium
            active
            createdAt
            updatedAt
          }
          focusAreaId
          focusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      tags
      lessonType
      metadata {
        videoUrl
        videoStreamUrl
        videoExternalId
        videoDistributionPage
        formUrl
        formExternalId
      }
      coverImageUrl
      isPremium
      active
      createdAt
      updatedAt
    }
  }
`;
export const createLessonFocusArea = /* GraphQL */ `
  mutation CreateLessonFocusArea(
    $input: CreateLessonFocusAreaInput!
    $condition: ModelLessonFocusAreaConditionInput
  ) {
    createLessonFocusArea(input: $input, condition: $condition) {
      lessonId
      lesson {
        id
        programId
        program {
          id
          name
          description
          level
          lessons {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        name
        order
        durationInMins
        description
        transcript
        focusAreas {
          items {
            lessonId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        tags
        lessonType
        metadata {
          videoUrl
          videoStreamUrl
          videoExternalId
          videoDistributionPage
          formUrl
          formExternalId
        }
        coverImageUrl
        isPremium
        active
        createdAt
        updatedAt
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateLessonFocusArea = /* GraphQL */ `
  mutation UpdateLessonFocusArea(
    $input: UpdateLessonFocusAreaInput!
    $condition: ModelLessonFocusAreaConditionInput
  ) {
    updateLessonFocusArea(input: $input, condition: $condition) {
      lessonId
      lesson {
        id
        programId
        program {
          id
          name
          description
          level
          lessons {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        name
        order
        durationInMins
        description
        transcript
        focusAreas {
          items {
            lessonId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        tags
        lessonType
        metadata {
          videoUrl
          videoStreamUrl
          videoExternalId
          videoDistributionPage
          formUrl
          formExternalId
        }
        coverImageUrl
        isPremium
        active
        createdAt
        updatedAt
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteLessonFocusArea = /* GraphQL */ `
  mutation DeleteLessonFocusArea(
    $input: DeleteLessonFocusAreaInput!
    $condition: ModelLessonFocusAreaConditionInput
  ) {
    deleteLessonFocusArea(input: $input, condition: $condition) {
      lessonId
      lesson {
        id
        programId
        program {
          id
          name
          description
          level
          lessons {
            nextToken
          }
          active
          createdAt
          updatedAt
        }
        name
        order
        durationInMins
        description
        transcript
        focusAreas {
          items {
            lessonId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        tags
        lessonType
        metadata {
          videoUrl
          videoStreamUrl
          videoExternalId
          videoDistributionPage
          formUrl
          formExternalId
        }
        coverImageUrl
        isPremium
        active
        createdAt
        updatedAt
      }
      focusAreaId
      focusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createPlanGroup = /* GraphQL */ `
  mutation CreatePlanGroup(
    $input: CreatePlanGroupInput!
    $condition: ModelPlanGroupConditionInput
  ) {
    createPlanGroup(input: $input, condition: $condition) {
      id
      name
      startDate
      endDate
      trialPeriod
      createdAt
      active
      plans {
        items {
          id
          planGroupId
          planGroup {
            id
            name
            startDate
            endDate
            trialPeriod
            createdAt
            active
            updatedAt
          }
          name
          description
          active
          defaultPrice
          defaultPlanPriceId
          discountsAllowed
          display
          isTrial
          upgradeable
          downgradeable
          features
          createdAt
          level
          pricing {
            nextToken
          }
          metadata {
            coachingSessionsAllocated
            stripeProductId
          }
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const updatePlanGroup = /* GraphQL */ `
  mutation UpdatePlanGroup(
    $input: UpdatePlanGroupInput!
    $condition: ModelPlanGroupConditionInput
  ) {
    updatePlanGroup(input: $input, condition: $condition) {
      id
      name
      startDate
      endDate
      trialPeriod
      createdAt
      active
      plans {
        items {
          id
          planGroupId
          planGroup {
            id
            name
            startDate
            endDate
            trialPeriod
            createdAt
            active
            updatedAt
          }
          name
          description
          active
          defaultPrice
          defaultPlanPriceId
          discountsAllowed
          display
          isTrial
          upgradeable
          downgradeable
          features
          createdAt
          level
          pricing {
            nextToken
          }
          metadata {
            coachingSessionsAllocated
            stripeProductId
          }
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const deletePlanGroup = /* GraphQL */ `
  mutation DeletePlanGroup(
    $input: DeletePlanGroupInput!
    $condition: ModelPlanGroupConditionInput
  ) {
    deletePlanGroup(input: $input, condition: $condition) {
      id
      name
      startDate
      endDate
      trialPeriod
      createdAt
      active
      plans {
        items {
          id
          planGroupId
          planGroup {
            id
            name
            startDate
            endDate
            trialPeriod
            createdAt
            active
            updatedAt
          }
          name
          description
          active
          defaultPrice
          defaultPlanPriceId
          discountsAllowed
          display
          isTrial
          upgradeable
          downgradeable
          features
          createdAt
          level
          pricing {
            nextToken
          }
          metadata {
            coachingSessionsAllocated
            stripeProductId
          }
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const createPlan = /* GraphQL */ `
  mutation CreatePlan(
    $input: CreatePlanInput!
    $condition: ModelPlanConditionInput
  ) {
    createPlan(input: $input, condition: $condition) {
      id
      planGroupId
      planGroup {
        id
        name
        startDate
        endDate
        trialPeriod
        createdAt
        active
        plans {
          items {
            id
            planGroupId
            name
            description
            active
            defaultPrice
            defaultPlanPriceId
            discountsAllowed
            display
            isTrial
            upgradeable
            downgradeable
            features
            createdAt
            level
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      name
      description
      active
      defaultPrice
      defaultPlanPriceId
      discountsAllowed
      display
      isTrial
      upgradeable
      downgradeable
      features
      createdAt
      level
      pricing {
        items {
          planId
          plan {
            id
            planGroupId
            name
            description
            active
            defaultPrice
            defaultPlanPriceId
            discountsAllowed
            display
            isTrial
            upgradeable
            downgradeable
            features
            createdAt
            level
            updatedAt
          }
          slug
          default
          activationCodes
          downgradePricingIds
          upgradePricingIds
          price
          metadata {
            stripePriceId
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      metadata {
        coachingSessionsAllocated
        stripeProductId
      }
      updatedAt
    }
  }
`;
export const updatePlan = /* GraphQL */ `
  mutation UpdatePlan(
    $input: UpdatePlanInput!
    $condition: ModelPlanConditionInput
  ) {
    updatePlan(input: $input, condition: $condition) {
      id
      planGroupId
      planGroup {
        id
        name
        startDate
        endDate
        trialPeriod
        createdAt
        active
        plans {
          items {
            id
            planGroupId
            name
            description
            active
            defaultPrice
            defaultPlanPriceId
            discountsAllowed
            display
            isTrial
            upgradeable
            downgradeable
            features
            createdAt
            level
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      name
      description
      active
      defaultPrice
      defaultPlanPriceId
      discountsAllowed
      display
      isTrial
      upgradeable
      downgradeable
      features
      createdAt
      level
      pricing {
        items {
          planId
          plan {
            id
            planGroupId
            name
            description
            active
            defaultPrice
            defaultPlanPriceId
            discountsAllowed
            display
            isTrial
            upgradeable
            downgradeable
            features
            createdAt
            level
            updatedAt
          }
          slug
          default
          activationCodes
          downgradePricingIds
          upgradePricingIds
          price
          metadata {
            stripePriceId
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      metadata {
        coachingSessionsAllocated
        stripeProductId
      }
      updatedAt
    }
  }
`;
export const deletePlan = /* GraphQL */ `
  mutation DeletePlan(
    $input: DeletePlanInput!
    $condition: ModelPlanConditionInput
  ) {
    deletePlan(input: $input, condition: $condition) {
      id
      planGroupId
      planGroup {
        id
        name
        startDate
        endDate
        trialPeriod
        createdAt
        active
        plans {
          items {
            id
            planGroupId
            name
            description
            active
            defaultPrice
            defaultPlanPriceId
            discountsAllowed
            display
            isTrial
            upgradeable
            downgradeable
            features
            createdAt
            level
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      name
      description
      active
      defaultPrice
      defaultPlanPriceId
      discountsAllowed
      display
      isTrial
      upgradeable
      downgradeable
      features
      createdAt
      level
      pricing {
        items {
          planId
          plan {
            id
            planGroupId
            name
            description
            active
            defaultPrice
            defaultPlanPriceId
            discountsAllowed
            display
            isTrial
            upgradeable
            downgradeable
            features
            createdAt
            level
            updatedAt
          }
          slug
          default
          activationCodes
          downgradePricingIds
          upgradePricingIds
          price
          metadata {
            stripePriceId
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      metadata {
        coachingSessionsAllocated
        stripeProductId
      }
      updatedAt
    }
  }
`;
export const createPlanPricing = /* GraphQL */ `
  mutation CreatePlanPricing(
    $input: CreatePlanPricingInput!
    $condition: ModelPlanPricingConditionInput
  ) {
    createPlanPricing(input: $input, condition: $condition) {
      planId
      plan {
        id
        planGroupId
        planGroup {
          id
          name
          startDate
          endDate
          trialPeriod
          createdAt
          active
          plans {
            nextToken
          }
          updatedAt
        }
        name
        description
        active
        defaultPrice
        defaultPlanPriceId
        discountsAllowed
        display
        isTrial
        upgradeable
        downgradeable
        features
        createdAt
        level
        pricing {
          items {
            planId
            slug
            default
            activationCodes
            downgradePricingIds
            upgradePricingIds
            price
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          coachingSessionsAllocated
          stripeProductId
        }
        updatedAt
      }
      slug
      default
      activationCodes
      downgradePricingIds
      upgradePricingIds
      price
      metadata {
        stripePriceId
      }
      createdAt
      updatedAt
    }
  }
`;
export const updatePlanPricing = /* GraphQL */ `
  mutation UpdatePlanPricing(
    $input: UpdatePlanPricingInput!
    $condition: ModelPlanPricingConditionInput
  ) {
    updatePlanPricing(input: $input, condition: $condition) {
      planId
      plan {
        id
        planGroupId
        planGroup {
          id
          name
          startDate
          endDate
          trialPeriod
          createdAt
          active
          plans {
            nextToken
          }
          updatedAt
        }
        name
        description
        active
        defaultPrice
        defaultPlanPriceId
        discountsAllowed
        display
        isTrial
        upgradeable
        downgradeable
        features
        createdAt
        level
        pricing {
          items {
            planId
            slug
            default
            activationCodes
            downgradePricingIds
            upgradePricingIds
            price
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          coachingSessionsAllocated
          stripeProductId
        }
        updatedAt
      }
      slug
      default
      activationCodes
      downgradePricingIds
      upgradePricingIds
      price
      metadata {
        stripePriceId
      }
      createdAt
      updatedAt
    }
  }
`;
export const deletePlanPricing = /* GraphQL */ `
  mutation DeletePlanPricing(
    $input: DeletePlanPricingInput!
    $condition: ModelPlanPricingConditionInput
  ) {
    deletePlanPricing(input: $input, condition: $condition) {
      planId
      plan {
        id
        planGroupId
        planGroup {
          id
          name
          startDate
          endDate
          trialPeriod
          createdAt
          active
          plans {
            nextToken
          }
          updatedAt
        }
        name
        description
        active
        defaultPrice
        defaultPlanPriceId
        discountsAllowed
        display
        isTrial
        upgradeable
        downgradeable
        features
        createdAt
        level
        pricing {
          items {
            planId
            slug
            default
            activationCodes
            downgradePricingIds
            upgradePricingIds
            price
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          coachingSessionsAllocated
          stripeProductId
        }
        updatedAt
      }
      slug
      default
      activationCodes
      downgradePricingIds
      upgradePricingIds
      price
      metadata {
        stripePriceId
      }
      createdAt
      updatedAt
    }
  }
`;
export const createEvent = /* GraphQL */ `
  mutation CreateEvent(
    $input: CreateEventInput!
    $condition: ModelEventConditionInput
  ) {
    createEvent(input: $input, condition: $condition) {
      id
      name
      title
      description
      features {
        title
        description
      }
      startDate
      endDate
      startTimestamp
      endTimestamp
      timezone
      hostFirstName
      hostLastName
      hostEmail
      hostWebsite
      hostAvatar
      allowFreeMembers
      allowSprout
      allowBloom
      eventType
      attendeeLimit
      attendees {
        items {
          eventSessionId
          eventSession {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          confirmed
          confirmationTimestamp
          metadata {
            paymentTimestamp
            stripeInvoiceId
            rawPaymentLog
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      times {
        items {
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          name
          title
          type
          description
          startDate
          endDate
          timezone
          allowFreeMembers
          allowSprout
          allowBloom
          metadata {
            acuityCalendarId
            acuityAppointmentTypeId
            meetingLinkVideo
            meetingLinkAudio
            recordingLink
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      sessions {
        items {
          id
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          sessionTitle
          sessionDescription
          startDate
          endDate
          startTimestamp
          endTimestamp
          timezone
          isRecurring
          allowFreeMembers
          allowSprout
          allowBloom
          attendeeLimit
          facilitators {
            nextToken
          }
          eventSessionAttendees {
            nextToken
          }
          times {
            nextToken
          }
          eventSessionFocusAreaId
          eventSessionFocusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          featureImageUrl
          metadata {
            chatChannelId
            eventSessionLandingPageUrl
            eventSessionMeetingLink
            actuityAppointmentTypeId
            acuityCalendarId
            activeCampaignTagId
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      price
      featureImageUrl
      metadata {
        stripeProductId
        stripePriceId
        eventLandingPageUrl
        eventMeetingLink
        activeCampaignTagId
        totalSessions
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateEvent = /* GraphQL */ `
  mutation UpdateEvent(
    $input: UpdateEventInput!
    $condition: ModelEventConditionInput
  ) {
    updateEvent(input: $input, condition: $condition) {
      id
      name
      title
      description
      features {
        title
        description
      }
      startDate
      endDate
      startTimestamp
      endTimestamp
      timezone
      hostFirstName
      hostLastName
      hostEmail
      hostWebsite
      hostAvatar
      allowFreeMembers
      allowSprout
      allowBloom
      eventType
      attendeeLimit
      attendees {
        items {
          eventSessionId
          eventSession {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          confirmed
          confirmationTimestamp
          metadata {
            paymentTimestamp
            stripeInvoiceId
            rawPaymentLog
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      times {
        items {
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          name
          title
          type
          description
          startDate
          endDate
          timezone
          allowFreeMembers
          allowSprout
          allowBloom
          metadata {
            acuityCalendarId
            acuityAppointmentTypeId
            meetingLinkVideo
            meetingLinkAudio
            recordingLink
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      sessions {
        items {
          id
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          sessionTitle
          sessionDescription
          startDate
          endDate
          startTimestamp
          endTimestamp
          timezone
          isRecurring
          allowFreeMembers
          allowSprout
          allowBloom
          attendeeLimit
          facilitators {
            nextToken
          }
          eventSessionAttendees {
            nextToken
          }
          times {
            nextToken
          }
          eventSessionFocusAreaId
          eventSessionFocusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          featureImageUrl
          metadata {
            chatChannelId
            eventSessionLandingPageUrl
            eventSessionMeetingLink
            actuityAppointmentTypeId
            acuityCalendarId
            activeCampaignTagId
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      price
      featureImageUrl
      metadata {
        stripeProductId
        stripePriceId
        eventLandingPageUrl
        eventMeetingLink
        activeCampaignTagId
        totalSessions
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteEvent = /* GraphQL */ `
  mutation DeleteEvent(
    $input: DeleteEventInput!
    $condition: ModelEventConditionInput
  ) {
    deleteEvent(input: $input, condition: $condition) {
      id
      name
      title
      description
      features {
        title
        description
      }
      startDate
      endDate
      startTimestamp
      endTimestamp
      timezone
      hostFirstName
      hostLastName
      hostEmail
      hostWebsite
      hostAvatar
      allowFreeMembers
      allowSprout
      allowBloom
      eventType
      attendeeLimit
      attendees {
        items {
          eventSessionId
          eventSession {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          confirmed
          confirmationTimestamp
          metadata {
            paymentTimestamp
            stripeInvoiceId
            rawPaymentLog
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      times {
        items {
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          name
          title
          type
          description
          startDate
          endDate
          timezone
          allowFreeMembers
          allowSprout
          allowBloom
          metadata {
            acuityCalendarId
            acuityAppointmentTypeId
            meetingLinkVideo
            meetingLinkAudio
            recordingLink
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      sessions {
        items {
          id
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          sessionTitle
          sessionDescription
          startDate
          endDate
          startTimestamp
          endTimestamp
          timezone
          isRecurring
          allowFreeMembers
          allowSprout
          allowBloom
          attendeeLimit
          facilitators {
            nextToken
          }
          eventSessionAttendees {
            nextToken
          }
          times {
            nextToken
          }
          eventSessionFocusAreaId
          eventSessionFocusArea {
            id
            name
            slug
            description
            createdAt
            updatedAt
          }
          featureImageUrl
          metadata {
            chatChannelId
            eventSessionLandingPageUrl
            eventSessionMeetingLink
            actuityAppointmentTypeId
            acuityCalendarId
            activeCampaignTagId
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      price
      featureImageUrl
      metadata {
        stripeProductId
        stripePriceId
        eventLandingPageUrl
        eventMeetingLink
        activeCampaignTagId
        totalSessions
      }
      createdAt
      updatedAt
    }
  }
`;
export const createEventTime = /* GraphQL */ `
  mutation CreateEventTime(
    $input: CreateEventTimeInput!
    $condition: ModelEventTimeConditionInput
  ) {
    createEventTime(input: $input, condition: $condition) {
      eventId
      event {
        id
        name
        title
        description
        features {
          title
          description
        }
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        hostFirstName
        hostLastName
        hostEmail
        hostWebsite
        hostAvatar
        allowFreeMembers
        allowSprout
        allowBloom
        eventType
        attendeeLimit
        attendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            allowFreeMembers
            allowSprout
            allowBloom
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          nextToken
        }
        price
        featureImageUrl
        metadata {
          stripeProductId
          stripePriceId
          eventLandingPageUrl
          eventMeetingLink
          activeCampaignTagId
          totalSessions
        }
        createdAt
        updatedAt
      }
      name
      title
      type
      description
      startDate
      endDate
      timezone
      allowFreeMembers
      allowSprout
      allowBloom
      metadata {
        acuityCalendarId
        acuityAppointmentTypeId
        meetingLinkVideo
        meetingLinkAudio
        recordingLink
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateEventTime = /* GraphQL */ `
  mutation UpdateEventTime(
    $input: UpdateEventTimeInput!
    $condition: ModelEventTimeConditionInput
  ) {
    updateEventTime(input: $input, condition: $condition) {
      eventId
      event {
        id
        name
        title
        description
        features {
          title
          description
        }
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        hostFirstName
        hostLastName
        hostEmail
        hostWebsite
        hostAvatar
        allowFreeMembers
        allowSprout
        allowBloom
        eventType
        attendeeLimit
        attendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            allowFreeMembers
            allowSprout
            allowBloom
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          nextToken
        }
        price
        featureImageUrl
        metadata {
          stripeProductId
          stripePriceId
          eventLandingPageUrl
          eventMeetingLink
          activeCampaignTagId
          totalSessions
        }
        createdAt
        updatedAt
      }
      name
      title
      type
      description
      startDate
      endDate
      timezone
      allowFreeMembers
      allowSprout
      allowBloom
      metadata {
        acuityCalendarId
        acuityAppointmentTypeId
        meetingLinkVideo
        meetingLinkAudio
        recordingLink
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteEventTime = /* GraphQL */ `
  mutation DeleteEventTime(
    $input: DeleteEventTimeInput!
    $condition: ModelEventTimeConditionInput
  ) {
    deleteEventTime(input: $input, condition: $condition) {
      eventId
      event {
        id
        name
        title
        description
        features {
          title
          description
        }
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        hostFirstName
        hostLastName
        hostEmail
        hostWebsite
        hostAvatar
        allowFreeMembers
        allowSprout
        allowBloom
        eventType
        attendeeLimit
        attendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            allowFreeMembers
            allowSprout
            allowBloom
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          nextToken
        }
        price
        featureImageUrl
        metadata {
          stripeProductId
          stripePriceId
          eventLandingPageUrl
          eventMeetingLink
          activeCampaignTagId
          totalSessions
        }
        createdAt
        updatedAt
      }
      name
      title
      type
      description
      startDate
      endDate
      timezone
      allowFreeMembers
      allowSprout
      allowBloom
      metadata {
        acuityCalendarId
        acuityAppointmentTypeId
        meetingLinkVideo
        meetingLinkAudio
        recordingLink
      }
      createdAt
      updatedAt
    }
  }
`;
export const createEventSession = /* GraphQL */ `
  mutation CreateEventSession(
    $input: CreateEventSessionInput!
    $condition: ModelEventSessionConditionInput
  ) {
    createEventSession(input: $input, condition: $condition) {
      id
      eventId
      event {
        id
        name
        title
        description
        features {
          title
          description
        }
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        hostFirstName
        hostLastName
        hostEmail
        hostWebsite
        hostAvatar
        allowFreeMembers
        allowSprout
        allowBloom
        eventType
        attendeeLimit
        attendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            allowFreeMembers
            allowSprout
            allowBloom
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          nextToken
        }
        price
        featureImageUrl
        metadata {
          stripeProductId
          stripePriceId
          eventLandingPageUrl
          eventMeetingLink
          activeCampaignTagId
          totalSessions
        }
        createdAt
        updatedAt
      }
      sessionTitle
      sessionDescription
      startDate
      endDate
      startTimestamp
      endTimestamp
      timezone
      isRecurring
      allowFreeMembers
      allowSprout
      allowBloom
      attendeeLimit
      facilitators {
        items {
          eventSessionId
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      eventSessionAttendees {
        items {
          eventSessionId
          eventSession {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          confirmed
          confirmationTimestamp
          metadata {
            paymentTimestamp
            stripeInvoiceId
            rawPaymentLog
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      times {
        items {
          eventSessionId
          eventSession {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          name
          title
          type
          description
          startDate
          endDate
          timezone
          metadata {
            acuityCalendarId
            acuityAppointmentTypeId
            meetingLinkVideo
            meetingLinkAudio
            recordingLink
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      eventSessionFocusAreaId
      eventSessionFocusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      featureImageUrl
      metadata {
        chatChannelId
        eventSessionLandingPageUrl
        eventSessionMeetingLink
        actuityAppointmentTypeId
        acuityCalendarId
        activeCampaignTagId
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateEventSession = /* GraphQL */ `
  mutation UpdateEventSession(
    $input: UpdateEventSessionInput!
    $condition: ModelEventSessionConditionInput
  ) {
    updateEventSession(input: $input, condition: $condition) {
      id
      eventId
      event {
        id
        name
        title
        description
        features {
          title
          description
        }
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        hostFirstName
        hostLastName
        hostEmail
        hostWebsite
        hostAvatar
        allowFreeMembers
        allowSprout
        allowBloom
        eventType
        attendeeLimit
        attendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            allowFreeMembers
            allowSprout
            allowBloom
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          nextToken
        }
        price
        featureImageUrl
        metadata {
          stripeProductId
          stripePriceId
          eventLandingPageUrl
          eventMeetingLink
          activeCampaignTagId
          totalSessions
        }
        createdAt
        updatedAt
      }
      sessionTitle
      sessionDescription
      startDate
      endDate
      startTimestamp
      endTimestamp
      timezone
      isRecurring
      allowFreeMembers
      allowSprout
      allowBloom
      attendeeLimit
      facilitators {
        items {
          eventSessionId
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      eventSessionAttendees {
        items {
          eventSessionId
          eventSession {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          confirmed
          confirmationTimestamp
          metadata {
            paymentTimestamp
            stripeInvoiceId
            rawPaymentLog
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      times {
        items {
          eventSessionId
          eventSession {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          name
          title
          type
          description
          startDate
          endDate
          timezone
          metadata {
            acuityCalendarId
            acuityAppointmentTypeId
            meetingLinkVideo
            meetingLinkAudio
            recordingLink
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      eventSessionFocusAreaId
      eventSessionFocusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      featureImageUrl
      metadata {
        chatChannelId
        eventSessionLandingPageUrl
        eventSessionMeetingLink
        actuityAppointmentTypeId
        acuityCalendarId
        activeCampaignTagId
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteEventSession = /* GraphQL */ `
  mutation DeleteEventSession(
    $input: DeleteEventSessionInput!
    $condition: ModelEventSessionConditionInput
  ) {
    deleteEventSession(input: $input, condition: $condition) {
      id
      eventId
      event {
        id
        name
        title
        description
        features {
          title
          description
        }
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        hostFirstName
        hostLastName
        hostEmail
        hostWebsite
        hostAvatar
        allowFreeMembers
        allowSprout
        allowBloom
        eventType
        attendeeLimit
        attendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            allowFreeMembers
            allowSprout
            allowBloom
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          nextToken
        }
        price
        featureImageUrl
        metadata {
          stripeProductId
          stripePriceId
          eventLandingPageUrl
          eventMeetingLink
          activeCampaignTagId
          totalSessions
        }
        createdAt
        updatedAt
      }
      sessionTitle
      sessionDescription
      startDate
      endDate
      startTimestamp
      endTimestamp
      timezone
      isRecurring
      allowFreeMembers
      allowSprout
      allowBloom
      attendeeLimit
      facilitators {
        items {
          eventSessionId
          coachId
          coach {
            id
            firstName
            lastName
            email
            title
            coachType
            avatarUrl
            description
            active
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      eventSessionAttendees {
        items {
          eventSessionId
          eventSession {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          userId
          user {
            id
            email
            firstName
            lastName
            phone
            avatar
            userBio
            age
            dateOfBirth
            genderId
            createdAt
            status
            lastSeen
            referralSource
            roles
            stage
            updatedAt
          }
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          confirmed
          confirmationTimestamp
          metadata {
            paymentTimestamp
            stripeInvoiceId
            rawPaymentLog
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      times {
        items {
          eventSessionId
          eventSession {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          eventId
          event {
            id
            name
            title
            description
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            hostFirstName
            hostLastName
            hostEmail
            hostWebsite
            hostAvatar
            allowFreeMembers
            allowSprout
            allowBloom
            eventType
            attendeeLimit
            price
            featureImageUrl
            createdAt
            updatedAt
          }
          name
          title
          type
          description
          startDate
          endDate
          timezone
          metadata {
            acuityCalendarId
            acuityAppointmentTypeId
            meetingLinkVideo
            meetingLinkAudio
            recordingLink
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      eventSessionFocusAreaId
      eventSessionFocusArea {
        id
        name
        slug
        description
        focusAreaGoals {
          items {
            id
            focusAreaId
            name
            slug
            description
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      featureImageUrl
      metadata {
        chatChannelId
        eventSessionLandingPageUrl
        eventSessionMeetingLink
        actuityAppointmentTypeId
        acuityCalendarId
        activeCampaignTagId
      }
      createdAt
      updatedAt
    }
  }
`;
export const createEventSessionTime = /* GraphQL */ `
  mutation CreateEventSessionTime(
    $input: CreateEventSessionTimeInput!
    $condition: ModelEventSessionTimeConditionInput
  ) {
    createEventSessionTime(input: $input, condition: $condition) {
      eventSessionId
      eventSession {
        id
        eventId
        event {
          id
          name
          title
          description
          features {
            title
            description
          }
          startDate
          endDate
          startTimestamp
          endTimestamp
          timezone
          hostFirstName
          hostLastName
          hostEmail
          hostWebsite
          hostAvatar
          allowFreeMembers
          allowSprout
          allowBloom
          eventType
          attendeeLimit
          attendees {
            nextToken
          }
          times {
            nextToken
          }
          sessions {
            nextToken
          }
          price
          featureImageUrl
          metadata {
            stripeProductId
            stripePriceId
            eventLandingPageUrl
            eventMeetingLink
            activeCampaignTagId
            totalSessions
          }
          createdAt
          updatedAt
        }
        sessionTitle
        sessionDescription
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        isRecurring
        allowFreeMembers
        allowSprout
        allowBloom
        attendeeLimit
        facilitators {
          items {
            eventSessionId
            coachId
            createdAt
            updatedAt
          }
          nextToken
        }
        eventSessionAttendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventSessionId
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            createdAt
            updatedAt
          }
          nextToken
        }
        eventSessionFocusAreaId
        eventSessionFocusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        featureImageUrl
        metadata {
          chatChannelId
          eventSessionLandingPageUrl
          eventSessionMeetingLink
          actuityAppointmentTypeId
          acuityCalendarId
          activeCampaignTagId
        }
        createdAt
        updatedAt
      }
      eventId
      event {
        id
        name
        title
        description
        features {
          title
          description
        }
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        hostFirstName
        hostLastName
        hostEmail
        hostWebsite
        hostAvatar
        allowFreeMembers
        allowSprout
        allowBloom
        eventType
        attendeeLimit
        attendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            allowFreeMembers
            allowSprout
            allowBloom
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          nextToken
        }
        price
        featureImageUrl
        metadata {
          stripeProductId
          stripePriceId
          eventLandingPageUrl
          eventMeetingLink
          activeCampaignTagId
          totalSessions
        }
        createdAt
        updatedAt
      }
      name
      title
      type
      description
      startDate
      endDate
      timezone
      metadata {
        acuityCalendarId
        acuityAppointmentTypeId
        meetingLinkVideo
        meetingLinkAudio
        recordingLink
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateEventSessionTime = /* GraphQL */ `
  mutation UpdateEventSessionTime(
    $input: UpdateEventSessionTimeInput!
    $condition: ModelEventSessionTimeConditionInput
  ) {
    updateEventSessionTime(input: $input, condition: $condition) {
      eventSessionId
      eventSession {
        id
        eventId
        event {
          id
          name
          title
          description
          features {
            title
            description
          }
          startDate
          endDate
          startTimestamp
          endTimestamp
          timezone
          hostFirstName
          hostLastName
          hostEmail
          hostWebsite
          hostAvatar
          allowFreeMembers
          allowSprout
          allowBloom
          eventType
          attendeeLimit
          attendees {
            nextToken
          }
          times {
            nextToken
          }
          sessions {
            nextToken
          }
          price
          featureImageUrl
          metadata {
            stripeProductId
            stripePriceId
            eventLandingPageUrl
            eventMeetingLink
            activeCampaignTagId
            totalSessions
          }
          createdAt
          updatedAt
        }
        sessionTitle
        sessionDescription
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        isRecurring
        allowFreeMembers
        allowSprout
        allowBloom
        attendeeLimit
        facilitators {
          items {
            eventSessionId
            coachId
            createdAt
            updatedAt
          }
          nextToken
        }
        eventSessionAttendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventSessionId
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            createdAt
            updatedAt
          }
          nextToken
        }
        eventSessionFocusAreaId
        eventSessionFocusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        featureImageUrl
        metadata {
          chatChannelId
          eventSessionLandingPageUrl
          eventSessionMeetingLink
          actuityAppointmentTypeId
          acuityCalendarId
          activeCampaignTagId
        }
        createdAt
        updatedAt
      }
      eventId
      event {
        id
        name
        title
        description
        features {
          title
          description
        }
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        hostFirstName
        hostLastName
        hostEmail
        hostWebsite
        hostAvatar
        allowFreeMembers
        allowSprout
        allowBloom
        eventType
        attendeeLimit
        attendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            allowFreeMembers
            allowSprout
            allowBloom
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          nextToken
        }
        price
        featureImageUrl
        metadata {
          stripeProductId
          stripePriceId
          eventLandingPageUrl
          eventMeetingLink
          activeCampaignTagId
          totalSessions
        }
        createdAt
        updatedAt
      }
      name
      title
      type
      description
      startDate
      endDate
      timezone
      metadata {
        acuityCalendarId
        acuityAppointmentTypeId
        meetingLinkVideo
        meetingLinkAudio
        recordingLink
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteEventSessionTime = /* GraphQL */ `
  mutation DeleteEventSessionTime(
    $input: DeleteEventSessionTimeInput!
    $condition: ModelEventSessionTimeConditionInput
  ) {
    deleteEventSessionTime(input: $input, condition: $condition) {
      eventSessionId
      eventSession {
        id
        eventId
        event {
          id
          name
          title
          description
          features {
            title
            description
          }
          startDate
          endDate
          startTimestamp
          endTimestamp
          timezone
          hostFirstName
          hostLastName
          hostEmail
          hostWebsite
          hostAvatar
          allowFreeMembers
          allowSprout
          allowBloom
          eventType
          attendeeLimit
          attendees {
            nextToken
          }
          times {
            nextToken
          }
          sessions {
            nextToken
          }
          price
          featureImageUrl
          metadata {
            stripeProductId
            stripePriceId
            eventLandingPageUrl
            eventMeetingLink
            activeCampaignTagId
            totalSessions
          }
          createdAt
          updatedAt
        }
        sessionTitle
        sessionDescription
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        isRecurring
        allowFreeMembers
        allowSprout
        allowBloom
        attendeeLimit
        facilitators {
          items {
            eventSessionId
            coachId
            createdAt
            updatedAt
          }
          nextToken
        }
        eventSessionAttendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventSessionId
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            createdAt
            updatedAt
          }
          nextToken
        }
        eventSessionFocusAreaId
        eventSessionFocusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        featureImageUrl
        metadata {
          chatChannelId
          eventSessionLandingPageUrl
          eventSessionMeetingLink
          actuityAppointmentTypeId
          acuityCalendarId
          activeCampaignTagId
        }
        createdAt
        updatedAt
      }
      eventId
      event {
        id
        name
        title
        description
        features {
          title
          description
        }
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        hostFirstName
        hostLastName
        hostEmail
        hostWebsite
        hostAvatar
        allowFreeMembers
        allowSprout
        allowBloom
        eventType
        attendeeLimit
        attendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            allowFreeMembers
            allowSprout
            allowBloom
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          nextToken
        }
        price
        featureImageUrl
        metadata {
          stripeProductId
          stripePriceId
          eventLandingPageUrl
          eventMeetingLink
          activeCampaignTagId
          totalSessions
        }
        createdAt
        updatedAt
      }
      name
      title
      type
      description
      startDate
      endDate
      timezone
      metadata {
        acuityCalendarId
        acuityAppointmentTypeId
        meetingLinkVideo
        meetingLinkAudio
        recordingLink
      }
      createdAt
      updatedAt
    }
  }
`;
export const createEventSessionFacilitator = /* GraphQL */ `
  mutation CreateEventSessionFacilitator(
    $input: CreateEventSessionFacilitatorInput!
    $condition: ModelEventSessionFacilitatorConditionInput
  ) {
    createEventSessionFacilitator(input: $input, condition: $condition) {
      eventSessionId
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateEventSessionFacilitator = /* GraphQL */ `
  mutation UpdateEventSessionFacilitator(
    $input: UpdateEventSessionFacilitatorInput!
    $condition: ModelEventSessionFacilitatorConditionInput
  ) {
    updateEventSessionFacilitator(input: $input, condition: $condition) {
      eventSessionId
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteEventSessionFacilitator = /* GraphQL */ `
  mutation DeleteEventSessionFacilitator(
    $input: DeleteEventSessionFacilitatorInput!
    $condition: ModelEventSessionFacilitatorConditionInput
  ) {
    deleteEventSessionFacilitator(input: $input, condition: $condition) {
      eventSessionId
      coachId
      coach {
        id
        firstName
        lastName
        email
        title
        coachType
        avatarUrl
        description
        metadata {
          introVideoUrl
          gcalId
          calendlyId
          acuityCalendarId
          acuityUserId
          acuityKey
          acuityIssAppointmentId
          acuityRegularAppointmentId
          streamChatId
          slackId
          lastCoachNote
          lastChatMessage
        }
        focusAreas {
          items {
            id
            coachId
            focusAreaId
            createdAt
            updatedAt
          }
          nextToken
        }
        members {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        active
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createEventSessionAttendees = /* GraphQL */ `
  mutation CreateEventSessionAttendees(
    $input: CreateEventSessionAttendeesInput!
    $condition: ModelEventSessionAttendeesConditionInput
  ) {
    createEventSessionAttendees(input: $input, condition: $condition) {
      eventSessionId
      eventSession {
        id
        eventId
        event {
          id
          name
          title
          description
          features {
            title
            description
          }
          startDate
          endDate
          startTimestamp
          endTimestamp
          timezone
          hostFirstName
          hostLastName
          hostEmail
          hostWebsite
          hostAvatar
          allowFreeMembers
          allowSprout
          allowBloom
          eventType
          attendeeLimit
          attendees {
            nextToken
          }
          times {
            nextToken
          }
          sessions {
            nextToken
          }
          price
          featureImageUrl
          metadata {
            stripeProductId
            stripePriceId
            eventLandingPageUrl
            eventMeetingLink
            activeCampaignTagId
            totalSessions
          }
          createdAt
          updatedAt
        }
        sessionTitle
        sessionDescription
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        isRecurring
        allowFreeMembers
        allowSprout
        allowBloom
        attendeeLimit
        facilitators {
          items {
            eventSessionId
            coachId
            createdAt
            updatedAt
          }
          nextToken
        }
        eventSessionAttendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventSessionId
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            createdAt
            updatedAt
          }
          nextToken
        }
        eventSessionFocusAreaId
        eventSessionFocusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        featureImageUrl
        metadata {
          chatChannelId
          eventSessionLandingPageUrl
          eventSessionMeetingLink
          actuityAppointmentTypeId
          acuityCalendarId
          activeCampaignTagId
        }
        createdAt
        updatedAt
      }
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      eventId
      event {
        id
        name
        title
        description
        features {
          title
          description
        }
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        hostFirstName
        hostLastName
        hostEmail
        hostWebsite
        hostAvatar
        allowFreeMembers
        allowSprout
        allowBloom
        eventType
        attendeeLimit
        attendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            allowFreeMembers
            allowSprout
            allowBloom
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          nextToken
        }
        price
        featureImageUrl
        metadata {
          stripeProductId
          stripePriceId
          eventLandingPageUrl
          eventMeetingLink
          activeCampaignTagId
          totalSessions
        }
        createdAt
        updatedAt
      }
      confirmed
      confirmationTimestamp
      metadata {
        paymentTimestamp
        stripeInvoiceId
        rawPaymentLog
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateEventSessionAttendees = /* GraphQL */ `
  mutation UpdateEventSessionAttendees(
    $input: UpdateEventSessionAttendeesInput!
    $condition: ModelEventSessionAttendeesConditionInput
  ) {
    updateEventSessionAttendees(input: $input, condition: $condition) {
      eventSessionId
      eventSession {
        id
        eventId
        event {
          id
          name
          title
          description
          features {
            title
            description
          }
          startDate
          endDate
          startTimestamp
          endTimestamp
          timezone
          hostFirstName
          hostLastName
          hostEmail
          hostWebsite
          hostAvatar
          allowFreeMembers
          allowSprout
          allowBloom
          eventType
          attendeeLimit
          attendees {
            nextToken
          }
          times {
            nextToken
          }
          sessions {
            nextToken
          }
          price
          featureImageUrl
          metadata {
            stripeProductId
            stripePriceId
            eventLandingPageUrl
            eventMeetingLink
            activeCampaignTagId
            totalSessions
          }
          createdAt
          updatedAt
        }
        sessionTitle
        sessionDescription
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        isRecurring
        allowFreeMembers
        allowSprout
        allowBloom
        attendeeLimit
        facilitators {
          items {
            eventSessionId
            coachId
            createdAt
            updatedAt
          }
          nextToken
        }
        eventSessionAttendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventSessionId
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            createdAt
            updatedAt
          }
          nextToken
        }
        eventSessionFocusAreaId
        eventSessionFocusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        featureImageUrl
        metadata {
          chatChannelId
          eventSessionLandingPageUrl
          eventSessionMeetingLink
          actuityAppointmentTypeId
          acuityCalendarId
          activeCampaignTagId
        }
        createdAt
        updatedAt
      }
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      eventId
      event {
        id
        name
        title
        description
        features {
          title
          description
        }
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        hostFirstName
        hostLastName
        hostEmail
        hostWebsite
        hostAvatar
        allowFreeMembers
        allowSprout
        allowBloom
        eventType
        attendeeLimit
        attendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            allowFreeMembers
            allowSprout
            allowBloom
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          nextToken
        }
        price
        featureImageUrl
        metadata {
          stripeProductId
          stripePriceId
          eventLandingPageUrl
          eventMeetingLink
          activeCampaignTagId
          totalSessions
        }
        createdAt
        updatedAt
      }
      confirmed
      confirmationTimestamp
      metadata {
        paymentTimestamp
        stripeInvoiceId
        rawPaymentLog
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteEventSessionAttendees = /* GraphQL */ `
  mutation DeleteEventSessionAttendees(
    $input: DeleteEventSessionAttendeesInput!
    $condition: ModelEventSessionAttendeesConditionInput
  ) {
    deleteEventSessionAttendees(input: $input, condition: $condition) {
      eventSessionId
      eventSession {
        id
        eventId
        event {
          id
          name
          title
          description
          features {
            title
            description
          }
          startDate
          endDate
          startTimestamp
          endTimestamp
          timezone
          hostFirstName
          hostLastName
          hostEmail
          hostWebsite
          hostAvatar
          allowFreeMembers
          allowSprout
          allowBloom
          eventType
          attendeeLimit
          attendees {
            nextToken
          }
          times {
            nextToken
          }
          sessions {
            nextToken
          }
          price
          featureImageUrl
          metadata {
            stripeProductId
            stripePriceId
            eventLandingPageUrl
            eventMeetingLink
            activeCampaignTagId
            totalSessions
          }
          createdAt
          updatedAt
        }
        sessionTitle
        sessionDescription
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        isRecurring
        allowFreeMembers
        allowSprout
        allowBloom
        attendeeLimit
        facilitators {
          items {
            eventSessionId
            coachId
            createdAt
            updatedAt
          }
          nextToken
        }
        eventSessionAttendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventSessionId
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            createdAt
            updatedAt
          }
          nextToken
        }
        eventSessionFocusAreaId
        eventSessionFocusArea {
          id
          name
          slug
          description
          focusAreaGoals {
            nextToken
          }
          createdAt
          updatedAt
        }
        featureImageUrl
        metadata {
          chatChannelId
          eventSessionLandingPageUrl
          eventSessionMeetingLink
          actuityAppointmentTypeId
          acuityCalendarId
          activeCampaignTagId
        }
        createdAt
        updatedAt
      }
      userId
      user {
        id
        email
        firstName
        lastName
        phone
        address {
          houseNumber
          street
          streetType
          address1
          address2
          address3
          city
          state
          postalCode
          county
          country
          latLng {
            lat
            lon
          }
        }
        avatar
        userBio
        age
        dateOfBirth
        genderId
        createdAt
        status
        lastSeen
        referralSource
        roles
        stage
        plans {
          items {
            id
            userId
            planId
            planGroupId
            planPricingSlug
            startDate
            endDate
            cancelled
            cancellationReason
            createdAt
            active
            updatedAt
          }
          nextToken
        }
        appointments {
          items {
            id
            userId
            coachId
            appointmentStartTime
            appointmentEndTime
            appointmentDurationMins
            appointmentTimezone
            appointmentType
            cancelled
            cancelDate
            cancelReason
            cancelNote
            createdAt
            updatedAt
          }
          nextToken
        }
        coaches {
          items {
            userId
            coachId
            isPrimary
            active
            coachingStartDate
            coachingEndDate
            createdAt
            updatedAt
          }
          nextToken
        }
        growthPaths {
          items {
            id
            growthPathItemId
            userId
            order
            dateTimeAdded
            completed
            dismissed
            completedTimestamp
            expirationDate
            locked
            hidden
            isScheduled
            visibleDate
            visibleTimestamp
            growthPathJourneyId
            growthPathJourneyStep
            coachId
            source
            lastActivityTimestamp
            dependsOnGrowthPathItems
            createdAt
            updatedAt
          }
          nextToken
        }
        metadata {
          lastLogin
          trialStartDate
          trialEndDate
          subscriptionStatus
          deviceId
          deviceOS
          deviceOSVersion
          allowAccountNotifications
          allowMarketingNotifications
          allowCoachingNotifications
          initialAssessmentCompletedDate
          lastWeeklyCheckinDate
          lastGrowthStageAssessmentDate
          primaryFocusCategoryId
          primaryFocusGoalId
          secondaryFocusCategoryId
          secondaryFocusGoalId
          tertiaryFocusCategoryId
          tertiaryFocusGoalId
          preferredCoachingTimeOfDay
          preferredCoachingDaysOfWeek
          primaryCoachId
          userIPAddress
          intakeCompleted
          onboardingCompleted
          issCompleted
          stipeCustomerId
          lastActive
        }
        updatedAt
      }
      eventId
      event {
        id
        name
        title
        description
        features {
          title
          description
        }
        startDate
        endDate
        startTimestamp
        endTimestamp
        timezone
        hostFirstName
        hostLastName
        hostEmail
        hostWebsite
        hostAvatar
        allowFreeMembers
        allowSprout
        allowBloom
        eventType
        attendeeLimit
        attendees {
          items {
            eventSessionId
            userId
            eventId
            confirmed
            confirmationTimestamp
            createdAt
            updatedAt
          }
          nextToken
        }
        times {
          items {
            eventId
            name
            title
            type
            description
            startDate
            endDate
            timezone
            allowFreeMembers
            allowSprout
            allowBloom
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            eventId
            sessionTitle
            sessionDescription
            startDate
            endDate
            startTimestamp
            endTimestamp
            timezone
            isRecurring
            allowFreeMembers
            allowSprout
            allowBloom
            attendeeLimit
            eventSessionFocusAreaId
            featureImageUrl
            createdAt
            updatedAt
          }
          nextToken
        }
        price
        featureImageUrl
        metadata {
          stripeProductId
          stripePriceId
          eventLandingPageUrl
          eventMeetingLink
          activeCampaignTagId
          totalSessions
        }
        createdAt
        updatedAt
      }
      confirmed
      confirmationTimestamp
      metadata {
        paymentTimestamp
        stripeInvoiceId
        rawPaymentLog
      }
      createdAt
      updatedAt
    }
  }
`;
